import { useState, useEffect, useRef } from "react";

// ─── LOCAL STORAGE ────────────────────────────────────────────────────────────
const LS = {
  get: (k)   => { try { return JSON.parse(localStorage.getItem(k)); } catch { return null; } },
  set: (k,v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} },
  del: (k)   => { try { localStorage.removeItem(k); } catch {} },
};

// Inicializa tabelas
if (!LS.get("dr_tasks"))  LS.set("dr_tasks", []);
if (!LS.get("dr_groups")) LS.set("dr_groups", []);

// Garante que o admin sempre existe
(()=>{
  const users = LS.get("dr_users") || [];
  const adminExists = users.find(u => u.email === "valterdossantosvieira@gmail.com");
  if (!adminExists) {
    users.unshift({
      id: "admin_001",
      email: "valterdossantosvieira@gmail.com",
      password: "123456",
      name: "Valter Vieira",
      phone: "", address: "", city: "",
      notif_enabled: true,
      notif_before: "15min"
    });
    LS.set("dr_users", users);
  }
})();

// ─── AUTH / DB (localStorage) ─────────────────────────────────────────────────
const supa = {
  auth: {
    async signIn(email, password) {
      const users = LS.get("dr_users") || [];
      const user  = users.find(u => u.email === email && u.password === password);
      if (!user) return { user:null, error:"E-mail ou senha incorretos." };
      const session = { id:user.id, email:user.email, name:user.name };
      LS.set("dr_session", session);
      return { user: session, error:null };
    },
    async signUp(email, password, name) {
      const users = LS.get("dr_users") || [];
      if (users.find(u => u.email === email))
        return { user:null, error:"Este e-mail já possui cadastro." };
      const id = "u_" + Date.now();
      const newUser = { id, email, password, name, phone:"", address:"", city:"", notif_enabled:true, notif_before:"15min" };
      users.push(newUser);
      LS.set("dr_users", users);
      const session = { id, email, name };
      LS.set("dr_session", session);
      return { user: session, error:null };
    },
    async signOut() {
      LS.del("dr_session");
    },
  },
  getProfile(userId) {
    const users = LS.get("dr_users") || [];
    return users.find(u => u.id === userId) || null;
  },
  saveProfile(userId, obj) {
    const users = LS.get("dr_users") || [];
    const updated = users.map(u => u.id === userId ? {...u, ...obj} : u);
    LS.set("dr_users", updated);
  },
  getTasks(userId) {
    const all = LS.get("dr_tasks") || [];
    return all.filter(t => t.user_id === userId);
  },
  saveTasks(tasks) {
    const all    = LS.get("dr_tasks") || [];
    const others = all.filter(t => !tasks.find(n => n.id === t.id));
    LS.set("dr_tasks", [...others, ...tasks]);
  },
  deleteTask(id) {
    const all = LS.get("dr_tasks") || [];
    LS.set("dr_tasks", all.filter(t => t.id !== id));
  },
  deleteGroup(groupId) {
    const all = LS.get("dr_tasks") || [];
    LS.set("dr_tasks", all.filter(t => t.groupId !== groupId));
  },
  updateTask(id, obj) {
    const all     = LS.get("dr_tasks") || [];
    const updated = all.map(t => t.id === id ? {...t, ...obj} : t);
    LS.set("dr_tasks", updated);
  },
};


// ─── TOKENS ───────────────────────────────────────────────────────────────────
const G = {
  // greens
  g900: "#0A3D1F",
  g700: "#166534",
  g500: "#16A34A",
  g400: "#22C55E",
  g200: "#BBF7D0",
  g100: "#DCFCE7",
  g50:  "#F0FDF4",
  // neutrals
  n900: "#0F172A",
  n700: "#334155",
  n500: "#64748B",
  n300: "#CBD5E1",
  n200: "#E2E8F0",
  n100: "#F1F5F9",
  n50:  "#F8FAFC",
  white:"#FFFFFF",
  // status
  red:  "#EF4444",
  amber:"#F59E0B",
  // glow
  glow: "rgba(22,163,74,0.12)",
};

const HEADING = "'Plus Jakarta Sans', 'Inter', sans-serif";
const BODY    = "'Inter', system-ui, sans-serif";

const CATS = ["🏠 Casa","💼 Trabalho","🏋️ Saúde","📚 Estudos","💰 Finanças","🎯 Pessoal","📦 Outros"];
const PRIS = ["Alta","Média","Baixa"];
const RECS = ["Nenhuma","Diária","Semanal","Mensal"];

const sortTasks = (arr) => [...arr].sort((a,b)=>{
  if(a.done!==b.done) return a.done?1:-1;
  const hasA = a.manualOrder!=null, hasB = b.manualOrder!=null;
  if(hasA && hasB) return a.manualOrder - b.manualOrder;
  if(hasA && !hasB) return -1;
  if(!hasA && hasB) return 1;
  const ta=a.time||"00:00", tb=b.time||"00:00";
  return ta<tb?-1:ta>tb?1:0;
});

const localDate = (d=new Date()) => {
  const y = d.getFullYear();
  const m = String(d.getMonth()+1).padStart(2,"0");
  const day = String(d.getDate()).padStart(2,"0");
  return `${y}-${m}-${day}`;
};
const tod  = () => localDate();
const tmr  = () => localDate(new Date(Date.now()+864e5));
const wend = () => localDate(new Date(Date.now()+7*864e5));


function fmtDate(d) {
  if (d===tod()) return "Hoje";
  if (d===tmr()) return "Amanhã";
  return new Date(d+"T00:00:00").toLocaleDateString("pt-BR",{weekday:"short",day:"2-digit",month:"short"});
}
function priColor(p) { return p==="Alta"?G.red:p==="Média"?G.amber:G.g500; }
function priBg(p)    { return p==="Alta"?"#FEF2F2":p==="Média"?"#FFFBEB":G.g50; }

// ─── CSS ──────────────────────────────────────────────────────────────────────
const GStyle = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Inter:wght@300;400;500;600&display=swap');
    *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; -webkit-tap-highlight-color:transparent; }
    html, body { background:${G.white}; }
    ::-webkit-scrollbar { width:3px; }
    ::-webkit-scrollbar-thumb { background:${G.n200}; border-radius:4px; }
    input::placeholder { color:${G.n300}; font-family:${BODY}; font-size:14px; }
    input[type=date]::-webkit-calendar-picker-indicator,
    input[type=time]::-webkit-calendar-picker-indicator { opacity:.45; cursor:pointer; }

    @keyframes fadeUp   { from{opacity:0;transform:translateY(12px)} to{opacity:1;transform:translateY(0)} }
    @keyframes slideUp  { from{transform:translateY(100%)} to{transform:translateY(0)} }
    @keyframes dot-blink{ 0%,100%{opacity:1} 50%{opacity:.3} }
    @keyframes progress { from{width:0} }

    .fade-up { animation:fadeUp .4s cubic-bezier(0.22,1,0.36,1) both; }
    .slide-up { animation:slideUp .38s cubic-bezier(0.22,1,0.36,1); }

    .task-row { transition:box-shadow .14s; cursor:default; }

    .pill-btn { transition:all .15s; }
    .pill-btn:hover { opacity:.85; }
    .pill-btn:active { transform:scale(.96); }

    .menu-row { transition:background .14s; }
    .menu-row:hover { background:${G.n50} !important; }

    .check-box { transition:all .2s; }
    .check-box:hover { border-color:${G.g500} !important; }
  `}</style>
);

// ─── SUBTLE BACKGROUND PATTERN ────────────────────────────────────────────────
function BgPattern() {
  return (
    <div style={{position:"fixed",inset:0,zIndex:0,pointerEvents:"none",overflow:"hidden"}}>
      {/* solid green hero band top-40% */}
      <div style={{position:"absolute",top:0,left:0,right:0,height:"42%",background:"linear-gradient(160deg,#166534 0%,#16A34A 60%,#22C55E 100%)"}}/>


      {/* soft overlap blend */}
      <div style={{position:"absolute",top:"30%",left:0,right:0,height:"18%",background:"linear-gradient(180deg,transparent,#F0FDF4)"}}/>
      {/* green light bottom */}
      <div style={{position:"absolute",bottom:0,left:0,right:0,height:"62%",background:"#F0FDF4"}}/>
      {/* large circle glow on green area */}
      <div style={{position:"absolute",top:"-80px",right:"-80px",width:"280px",height:"280px",borderRadius:"50%",background:"radial-gradient(circle,rgba(255,255,255,.18) 0%,transparent 65%)"}}/>
      <div style={{position:"absolute",top:"5%",left:"-40px",width:"180px",height:"180px",borderRadius:"50%",background:"radial-gradient(circle,rgba(255,255,255,.10) 0%,transparent 65%)"}}/>
      {/* SVG icons ON the green band */}
      <svg style={{position:"absolute",top:0,left:0,width:"100%",height:"42%"}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 390 280" preserveAspectRatio="xMidYMid slice">
        {/* ── ICON LAYER ── */}
        {/* checklist top-left */}
        <g transform="translate(14,28) rotate(-10,24,29)" stroke="rgba(255,255,255,.38)" strokeWidth="2" fill="none" strokeLinecap="round">
          <rect x="0" y="0" width="48" height="58" rx="7"/>
          <path d="M10 18 L17 25 L32 12"/>
          <line x1="10" y1="34" x2="38" y2="34"/>
          <line x1="10" y1="44" x2="30" y2="44"/>
        </g>
        {/* bar chart top-right */}
        <g transform="translate(312,14) rotate(8,28,26)" stroke="rgba(255,255,255,.32)" strokeWidth="2" fill="none" strokeLinecap="round">
          <rect x="0" y="28" width="14" height="32" rx="2"/>
          <rect x="18" y="14" width="14" height="46" rx="2"/>
          <rect x="36" y="0" width="14" height="60" rx="2"/>
        </g>
        {/* clock top-centre */}
        <g transform="translate(172,12) rotate(5,20,20)" stroke="rgba(255,255,255,.25)" strokeWidth="2" fill="none" strokeLinecap="round">
          <circle cx="20" cy="20" r="18"/>
          <path d="M20 8 L20 20 L28 26"/>
          <circle cx="20" cy="4" r="1.5" fill="rgba(255,255,255,.25)"/>
          <circle cx="36" cy="20" r="1.5" fill="rgba(255,255,255,.25)"/>
          <circle cx="20" cy="36" r="1.5" fill="rgba(255,255,255,.25)"/>
          <circle cx="4"  cy="20" r="1.5" fill="rgba(255,255,255,.25)"/>
        </g>
        {/* calendar mid-left */}
        <g transform="translate(12,130) rotate(-6,24,22)" stroke="rgba(255,255,255,.28)" strokeWidth="1.8" fill="none" strokeLinecap="round">
          <rect x="0" y="6" width="46" height="40" rx="5"/>
          <line x1="0" y1="16" x2="46" y2="16"/>
          <line x1="12" y1="0" x2="12" y2="12"/>
          <line x1="34" y1="0" x2="34" y2="12"/>
          <circle cx="12" cy="28" r="2" fill="rgba(255,255,255,.28)"/>
          <circle cx="23" cy="28" r="2" fill="rgba(255,255,255,.28)"/>
          <circle cx="34" cy="28" r="2" fill="rgba(255,255,255,.28)"/>
          <circle cx="12" cy="38" r="2" fill="rgba(255,255,255,.28)"/>
          <circle cx="23" cy="38" r="2" fill="rgba(255,255,255,.28)"/>
        </g>
        {/* checklist mid-right */}
        <g transform="translate(318,110) rotate(12,22,28)" stroke="rgba(255,255,255,.26)" strokeWidth="1.8" fill="none" strokeLinecap="round">
          <rect x="0" y="0" width="44" height="54" rx="6"/>
          <path d="M9 16 L15 22 L30 10"/>
          <line x1="9" y1="30" x2="35" y2="30"/>
          <line x1="9" y1="40" x2="27" y2="40"/>
        </g>
        {/* small bar chart bottom-centre */}
        <g transform="translate(168,170) rotate(-5,18,18)" stroke="rgba(255,255,255,.22)" strokeWidth="1.8" fill="none" strokeLinecap="round">
          <rect x="0" y="18" width="10" height="20" rx="2"/>
          <rect x="14" y="8"  width="10" height="30" rx="2"/>
          <rect x="28" y="0"  width="10" height="38" rx="2"/>
        </g>
        {/* check circles scattered */}
        <g stroke="rgba(255,255,255,.22)" strokeWidth="1.8" fill="none" strokeLinecap="round">
          <circle cx="88"  cy="88"  r="14"/><path d="M80 88 L86 94 L96 82"/>
          <circle cx="302" cy="76"  r="12"/><path d="M295 76 L300 81 L309 70"/>
          <circle cx="72"  cy="210" r="12"/><path d="M65 210 L70 215 L79 204"/>
          <circle cx="320" cy="200" r="14"/><path d="M312 200 L318 206 L328 194"/>
          <circle cx="190" cy="245" r="10"/><path d="M184 245 L188 249 L196 240"/>
        </g>
        {/* tag / label icons */}
        <g stroke="rgba(255,255,255,.20)" strokeWidth="1.8" fill="none" strokeLinecap="round">
          <path d="M120 130 L142 130 L154 142 L142 154 L120 154 Z"/>
          <circle cx="128" cy="142" r="3" fill="rgba(255,255,255,.20)"/>
          <path d="M230 160 L250 160 L260 170 L250 180 L230 180 Z"/>
          <circle cx="238" cy="170" r="2.5" fill="rgba(255,255,255,.20)"/>
        </g>
        {/* ── FULL DOT GRID covering entire height ── */}
        <g fill="rgba(255,255,255,.13)">
          <circle cx="55"  cy="15" r="2.2"/><circle cx="95"  cy="15" r="2.2"/><circle cx="135" cy="15" r="2.2"/>
          <circle cx="215" cy="15" r="2.2"/><circle cx="255" cy="15" r="2.2"/><circle cx="295" cy="15" r="2.2"/>
          <circle cx="35"  cy="45" r="2"/><circle cx="75"  cy="45" r="2"/><circle cx="195" cy="45" r="2"/>
          <circle cx="235" cy="45" r="2"/><circle cx="275" cy="45" r="2"/><circle cx="355" cy="45" r="2"/>
          <circle cx="115" cy="75" r="2"/><circle cx="155" cy="75" r="2"/><circle cx="255" cy="75" r="2"/>
          <circle cx="335" cy="75" r="2"/><circle cx="375" cy="75" r="2"/>
          <circle cx="55"  cy="105" r="2"/><circle cx="195" cy="105" r="2"/><circle cx="235" cy="105" r="2"/>
          <circle cx="355" cy="105" r="2"/>
          <circle cx="75"  cy="135" r="2"/><circle cx="155" cy="135" r="2"/><circle cx="295" cy="135" r="2"/>
          <circle cx="375" cy="135" r="2"/>
          <circle cx="35"  cy="165" r="2"/><circle cx="115" cy="165" r="2"/><circle cx="215" cy="165" r="2"/>
          <circle cx="335" cy="165" r="2"/>
          <circle cx="55"  cy="195" r="2"/><circle cx="135" cy="195" r="2"/><circle cx="255" cy="195" r="2"/>
          <circle cx="375" cy="195" r="2"/>
          <circle cx="95"  cy="225" r="2"/><circle cx="215" cy="225" r="2"/><circle cx="295" cy="225" r="2"/>
          <circle cx="355" cy="225" r="2"/>
          <circle cx="35"  cy="255" r="2"/><circle cx="155" cy="255" r="2"/><circle cx="235" cy="255" r="2"/>
          <circle cx="315" cy="255" r="2"/>
        </g>
      </svg>

    </div>
  );
}


// ─── APP BACKGROUND (dark green full screen, same style as login top) ──────────
function AppBgPattern() {
  return (
    <div style={{position:"fixed",inset:0,zIndex:0,pointerEvents:"none",overflow:"hidden"}}>
      {/* full dark green */}
      <div style={{position:"absolute",inset:0,background:"linear-gradient(160deg,#166534 0%,#16A34A 60%,#14532D 100%)"}}/>
      {/* circle glows */}
      <div style={{position:"absolute",top:"-80px",right:"-80px",width:"280px",height:"280px",borderRadius:"50%",background:"radial-gradient(circle,rgba(255,255,255,.10) 0%,transparent 65%)"}}/>
      <div style={{position:"absolute",top:"5%",left:"-40px",width:"180px",height:"180px",borderRadius:"50%",background:"radial-gradient(circle,rgba(255,255,255,.07) 0%,transparent 65%)"}}/>
      <div style={{position:"absolute",bottom:"-60px",right:"-60px",width:"220px",height:"220px",borderRadius:"50%",background:"radial-gradient(circle,rgba(255,255,255,.06) 0%,transparent 65%)"}}/>
      {/* icons + dots covering full screen */}
      <svg style={{position:"absolute",top:0,left:0,width:"100%",height:"100%"}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 390 700" preserveAspectRatio="xMidYMid slice">
        {/* checklist top-left */}
        <g transform="translate(16,40) rotate(-10,24,29)" stroke="rgba(255,255,255,.28)" strokeWidth="2" fill="none" strokeLinecap="round">
          <rect x="0" y="0" width="48" height="58" rx="7"/>
          <path d="M10 18 L17 25 L32 12"/>
          <line x1="10" y1="34" x2="38" y2="34"/>
          <line x1="10" y1="44" x2="30" y2="44"/>
        </g>
        {/* bar chart top-right */}
        <g transform="translate(292,22) rotate(8,28,26)" stroke="rgba(255,255,255,.25)" strokeWidth="2" fill="none" strokeLinecap="round">
          <rect x="0" y="28" width="14" height="32" rx="2"/>
          <rect x="18" y="14" width="14" height="46" rx="2"/>
          <rect x="36" y="0"  width="14" height="60" rx="2"/>
        </g>
        {/* clock top-centre */}
        <g transform="translate(172,12) rotate(5,20,20)" stroke="rgba(255,255,255,.20)" strokeWidth="2" fill="none" strokeLinecap="round">
          <circle cx="20" cy="20" r="18"/>
          <path d="M20 8 L20 20 L28 26"/>
        </g>
        {/* calendar mid-left */}
        <g transform="translate(12,200) rotate(-6,24,22)" stroke="rgba(255,255,255,.22)" strokeWidth="1.8" fill="none" strokeLinecap="round">
          <rect x="0" y="6" width="46" height="40" rx="5"/>
          <line x1="0" y1="16" x2="46" y2="16"/>
          <line x1="12" y1="0" x2="12" y2="12"/>
          <line x1="34" y1="0" x2="34" y2="12"/>
          <circle cx="12" cy="28" r="2" fill="rgba(255,255,255,.22)"/>
          <circle cx="23" cy="28" r="2" fill="rgba(255,255,255,.22)"/>
          <circle cx="34" cy="28" r="2" fill="rgba(255,255,255,.22)"/>
        </g>
        {/* checklist mid-right */}
        <g transform="translate(318,190) rotate(12,22,28)" stroke="rgba(255,255,255,.20)" strokeWidth="1.8" fill="none" strokeLinecap="round">
          <rect x="0" y="0" width="44" height="54" rx="6"/>
          <path d="M9 16 L15 22 L30 10"/>
          <line x1="9" y1="30" x2="35" y2="30"/>
          <line x1="9" y1="40" x2="27" y2="40"/>
        </g>
        {/* bar chart bottom-centre */}
        <g transform="translate(162,390) rotate(-5,18,18)" stroke="rgba(255,255,255,.18)" strokeWidth="1.8" fill="none" strokeLinecap="round">
          <rect x="0" y="18" width="10" height="20" rx="2"/>
          <rect x="14" y="8"  width="10" height="30" rx="2"/>
          <rect x="28" y="0"  width="10" height="38" rx="2"/>
        </g>
        {/* clock bottom-left */}
        <g transform="translate(14,430) rotate(8,20,20)" stroke="rgba(255,255,255,.18)" strokeWidth="1.8" fill="none" strokeLinecap="round">
          <circle cx="20" cy="20" r="18"/>
          <path d="M20 8 L20 20 L28 26"/>
        </g>
        {/* calendar bottom-right */}
        <g transform="translate(300,500) rotate(-7,22,20)" stroke="rgba(255,255,255,.18)" strokeWidth="1.8" fill="none" strokeLinecap="round">
          <rect x="0" y="5" width="42" height="36" rx="4"/>
          <line x1="0" y1="14" x2="42" y2="14"/>
          <line x1="11" y1="0" x2="11" y2="10"/>
          <line x1="31" y1="0" x2="31" y2="10"/>
          <circle cx="11" cy="24" r="2" fill="rgba(255,255,255,.18)"/>
          <circle cx="21" cy="24" r="2" fill="rgba(255,255,255,.18)"/>
          <circle cx="31" cy="24" r="2" fill="rgba(255,255,255,.18)"/>
        </g>
        {/* check circles */}
        <g stroke="rgba(255,255,255,.20)" strokeWidth="1.8" fill="none" strokeLinecap="round">
          <circle cx="88"  cy="120" r="13"/><path d="M81 120 L86 125 L95 114"/>
          <circle cx="302" cy="100" r="12"/><path d="M295 100 L300 105 L309 94"/>
          <circle cx="60"  cy="340" r="12"/><path d="M53 340 L58 345 L67 334"/>
          <circle cx="330" cy="370" r="13"/><path d="M323 370 L328 375 L337 364"/>
          <circle cx="180" cy="560" r="11"/><path d="M174 560 L178 564 L186 555"/>
          <circle cx="350" cy="620" r="12"/><path d="M343 620 L348 625 L357 614"/>
        </g>
        {/* dots grid full height */}
        <g fill="rgba(255,255,255,.12)">
          <circle cx="55"  cy="15"  r="2"/><circle cx="135" cy="15"  r="2"/><circle cx="215" cy="15"  r="2"/><circle cx="295" cy="15"  r="2"/><circle cx="375" cy="15"  r="2"/>
          <circle cx="35"  cy="50"  r="2"/><circle cx="115" cy="50"  r="2"/><circle cx="195" cy="50"  r="2"/><circle cx="275" cy="50"  r="2"/><circle cx="355" cy="50"  r="2"/>
          <circle cx="75"  cy="85"  r="2"/><circle cx="155" cy="85"  r="2"/><circle cx="235" cy="85"  r="2"/><circle cx="315" cy="85"  r="2"/>
          <circle cx="55"  cy="120" r="2"/><circle cx="175" cy="120" r="2"/><circle cx="255" cy="120" r="2"/><circle cx="375" cy="120" r="2"/>
          <circle cx="95"  cy="155" r="2"/><circle cx="215" cy="155" r="2"/><circle cx="335" cy="155" r="2"/>
          <circle cx="35"  cy="190" r="2"/><circle cx="155" cy="190" r="2"/><circle cx="275" cy="190" r="2"/><circle cx="375" cy="190" r="2"/>
          <circle cx="75"  cy="225" r="2"/><circle cx="195" cy="225" r="2"/><circle cx="315" cy="225" r="2"/>
          <circle cx="55"  cy="260" r="2"/><circle cx="135" cy="260" r="2"/><circle cx="255" cy="260" r="2"/><circle cx="355" cy="260" r="2"/>
          <circle cx="95"  cy="295" r="2"/><circle cx="215" cy="295" r="2"/><circle cx="335" cy="295" r="2"/>
          <circle cx="35"  cy="330" r="2"/><circle cx="155" cy="330" r="2"/><circle cx="375" cy="330" r="2"/>
          <circle cx="75"  cy="365" r="2"/><circle cx="195" cy="365" r="2"/><circle cx="315" cy="365" r="2"/>
          <circle cx="115" cy="400" r="2"/><circle cx="235" cy="400" r="2"/><circle cx="355" cy="400" r="2"/>
          <circle cx="55"  cy="435" r="2"/><circle cx="175" cy="435" r="2"/><circle cx="295" cy="435" r="2"/>
          <circle cx="95"  cy="470" r="2"/><circle cx="215" cy="470" r="2"/><circle cx="375" cy="470" r="2"/>
          <circle cx="35"  cy="505" r="2"/><circle cx="155" cy="505" r="2"/><circle cx="275" cy="505" r="2"/>
          <circle cx="75"  cy="540" r="2"/><circle cx="235" cy="540" r="2"/><circle cx="355" cy="540" r="2"/>
          <circle cx="115" cy="575" r="2"/><circle cx="195" cy="575" r="2"/><circle cx="315" cy="575" r="2"/>
          <circle cx="55"  cy="610" r="2"/><circle cx="175" cy="610" r="2"/><circle cx="375" cy="610" r="2"/>
          <circle cx="95"  cy="645" r="2"/><circle cx="215" cy="645" r="2"/><circle cx="295" cy="645" r="2"/>
          <circle cx="35"  cy="680" r="2"/><circle cx="155" cy="680" r="2"/><circle cx="335" cy="680" r="2"/>
        </g>
      </svg>
    </div>
  );
}

// ─── INPUT ────────────────────────────────────────────────────────────────────
// eslint-disable-next-line no-unused-vars
function Input({ label, ...props }) {
  const [focus, setFocus] = useState(false);
  return (
    <div>
      {label && <label style={{display:"block",color:G.n500,fontSize:"11px",fontWeight:"600",
        letterSpacing:"0.7px",textTransform:"uppercase",marginBottom:"4px",fontFamily:BODY}}>{label}</label>}
      <input {...props}
        onFocus={e=>{ setFocus(true); props.onFocus&&props.onFocus(e); }}
        onBlur={e=>{ setFocus(false); props.onBlur&&props.onBlur(e); }}
        style={{
          width:"100%", background:G.white,
          border:`1.5px solid ${focus ? G.g500 : G.n200}`,
          borderRadius:"10px", padding:"11px 14px",
          color:G.n900, fontSize:"14px", fontFamily:BODY,
          outline:"none", transition:"border-color .18s, box-shadow .18s",
          boxShadow: focus ? `0 0 0 3px ${G.glow}` : "none",
          ...(props.style||{})
        }}
      />
    </div>
  );
}

// ─── LOGIN ────────────────────────────────────────────────────────────────────
function LoginScreen({ onLogin }) {
  const [mode]  = useState("login");
  const [email, setEmail] = useState("");
  const [pass,  setPass]  = useState("");
  const [name] = useState("");
  const [busy,  setBusy]  = useState(false);
  const [ready, setReady] = useState(false);
  const [err,   setErr]   = useState("");

  useEffect(() => { setTimeout(()=>setReady(true), 60); }, []);

  const submit = async () => {
    if (!email || !pass) { setErr("Preencha e-mail e senha."); return; }
    setBusy(true); setErr("");
    try {
      if (mode === "login") {
        const { user, error } = await supa.auth.signIn(email, pass);
        if (error) throw new Error(error);
        onLogin({ id: user.id, name: user.name || user.email.split("@")[0], email: user.email });
      } else {
        if (!name) { setErr("Preencha seu nome."); setBusy(false); return; }
        const { user, error } = await supa.auth.signUp(email, pass, name);
        if (error) throw new Error(error);
        if (user?.id) {
          onLogin({ id: user.id, name: user.name || name, email: user.email });
        }
      }
    } catch(e) {
      const msgs = {
        "Invalid login credentials": "E-mail ou senha incorretos.",
        "Email not confirmed": "Confirme seu e-mail antes de entrar.",
        "User already registered": "Este e-mail já possui cadastro.",
      };
      setErr(msgs[e.message] || e.message);
    } finally { setBusy(false); }
  };

  const iStyle = {
    width:"100%", background:G.n50, border:`1.5px solid ${G.n200}`,
    borderRadius:"10px", padding:"13px 14px", color:G.n900, fontSize:"15px",
    fontFamily:BODY, outline:"none", transition:"border-color .18s", boxSizing:"border-box"
  };

  return (
    <div style={{minHeight:"100vh",background:"transparent",display:"flex",flexDirection:"column",position:"relative",overflow:"hidden"}}>
      <GStyle/><BgPattern/>

      <div style={{
        flex:1, display:"flex", flexDirection:"column", justifyContent:"flex-start",
        padding:"60px 24px 24px", position:"relative", zIndex:1,
        opacity:ready?1:0, transform:ready?"translateY(0)":"translateY(16px)",
        transition:"all .55s cubic-bezier(0.22,1,0.36,1)"
      }}>
        {/* Logo + título */}
        <div style={{marginBottom:"28px"}}>
          <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"16px"}}>
            <div style={{
              width:"44px",height:"44px",borderRadius:"14px",flexShrink:0,
              background:"linear-gradient(135deg,#FFFFFF,rgba(255,255,255,.85))",
              display:"flex",alignItems:"center",justifyContent:"center",
              boxShadow:"0 4px 16px rgba(0,0,0,.2)"
            }}>
              <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                <rect x="2" y="2" width="22" height="22" rx="6" fill={G.g700}/>
                <path d="M7 13L11 17L19 9" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div style={{lineHeight:1}}>
              <span style={{fontFamily:HEADING,fontSize:"22px",fontWeight:"800",color:"#FFFFFF",letterSpacing:"-0.5px"}}>Dia </span>
              <span style={{fontFamily:HEADING,fontSize:"22px",fontWeight:"800",color:G.g200||"#BBF7D0",letterSpacing:"-0.5px",textShadow:"0 0 20px rgba(187,247,208,.5)"}}>Resolvido</span>
            </div>
          </div>
          <h1 style={{fontFamily:HEADING,fontSize:"30px",fontWeight:"800",color:"#FFFFFF",letterSpacing:"-1px",lineHeight:1.1,marginBottom:"6px"}}>
            {mode==="login" ? "Bem-vindo." : "Criar conta."}
          </h1>
          <p style={{color:"rgba(255,255,255,.75)",fontSize:"14px",fontFamily:BODY,lineHeight:1.5}}>
            {mode==="login" ? "Entre com seu e-mail e senha." : "Preencha seus dados para começar."}
          </p>
        </div>

        {/* Card branco com form */}
        <div style={{background:"#FFFFFF",borderRadius:"20px",padding:"24px",boxShadow:"0 8px 40px rgba(0,0,0,.18)"}}>
          <div style={{display:"flex",flexDirection:"column",gap:"14px"}}>

            <div>
              <label style={{display:"block",color:G.n900,fontSize:"11px",fontWeight:"700",letterSpacing:"0.7px",textTransform:"uppercase",marginBottom:"4px",fontFamily:BODY}}>E-mail</label>
              <input value={email} onChange={e=>setEmail(e.target.value)} placeholder="voce@email.com" type="email"
                style={iStyle}
                onFocus={e=>{e.target.style.borderColor=G.g500; e.target.style.background=G.white;}}
                onBlur={e=>{e.target.style.borderColor=G.n200; e.target.style.background=G.n50;}}
              />
            </div>
            <div>
              <label style={{display:"block",color:G.n900,fontSize:"11px",fontWeight:"700",letterSpacing:"0.7px",textTransform:"uppercase",marginBottom:"4px",fontFamily:BODY}}>Senha</label>
              <input value={pass} onChange={e=>setPass(e.target.value)} placeholder="••••••••" type="password"
                style={iStyle}
                onFocus={e=>{e.target.style.borderColor=G.g500; e.target.style.background=G.white;}}
                onBlur={e=>{e.target.style.borderColor=G.n200; e.target.style.background=G.n50;}}
                onKeyDown={e=>e.key==="Enter"&&submit()}
              />
              {mode==="login" && (
                <p style={{textAlign:"right",marginTop:"6px"}}>
                  <span style={{color:G.g500,fontSize:"12px",fontWeight:"600",cursor:"pointer",fontFamily:BODY}}>Esqueceu a senha?</span>
                </p>
              )}
            </div>

            {err && (
              <div style={{background:"#FEF2F2",border:"1px solid #FECACA",borderRadius:"8px",padding:"10px 14px",display:"flex",gap:"8px",alignItems:"flex-start"}}>
                <span style={{fontSize:"14px",flexShrink:0}}>⚠️</span>
                <p style={{color:G.red,fontFamily:BODY,fontSize:"13px",lineHeight:1.4}}>{err}</p>
              </div>
            )}

            <button onClick={submit} disabled={busy} style={{
              width:"100%", background:busy?G.n300:G.g500, color:G.white,
              border:"none", borderRadius:"12px", padding:"14px",
              fontSize:"15px", fontWeight:"700", fontFamily:BODY,
              cursor:busy?"not-allowed":"pointer",
              boxShadow:busy?"none":`0 4px 16px ${G.glow}`,
              transition:"all .2s", letterSpacing:"0.2px"
            }}>
              {busy ? "Aguarde…" : mode==="login" ? "Entrar" : "Criar conta"}
            </button>
          </div>

          <div style={{textAlign:"center",marginTop:"14px",paddingTop:"14px",borderTop:`1px solid ${G.n100}`}}>
            <p style={{color:G.n300,fontSize:"12px",fontFamily:BODY}}>Acesso restrito · <strong style={{color:G.g700}}>Dia Resolvido</strong></p>
          </div>
        </div>
      </div>

      {/* footer */}
      <div style={{textAlign:"center",padding:"10px 16px 24px",position:"relative",zIndex:1}}>
        <p style={{color:"rgba(255,255,255,.45)",fontSize:"11px",fontFamily:BODY,marginBottom:"4px"}}>Seguro · Criptografado · Dia Resolvido © 2026</p>
        <p style={{color:"rgba(255,255,255,.6)",fontSize:"12px",fontFamily:BODY}}>Um aplicativo <strong style={{color:"rgba(255,255,255,.9)",fontWeight:"700"}}>V&V Consultoria</strong></p>
      </div>
    </div>
  );
}

// ─── TASK CARD ────────────────────────────────────────────────────────────────
function TaskCard({ task, onToggle, onEdit, onDelete, i=0, onHandleTouchStart, onHandleTouchMove, onHandleTouchEnd }) {

  return (
    <div className="task-row fade-up" style={{
      animationDelay:`${i*.04}s`,
      background: G.white,
      border:`1px solid ${G.n200}`,
      borderRadius:"12px", padding:"6px 12px",
      opacity: 1,
      boxShadow: "0 1px 4px rgba(0,0,0,.06)",
      transition:"all .18s"
    }}>

      {/* Row 1: Título + Editar + Remover + #01 */}
      <div style={{display:"flex",alignItems:"flex-start",gap:"8px",marginBottom:"6px"}}>
        <p style={{
          color: task.done ? G.n300 : G.n900,
          fontSize:"13px",fontWeight:"700",fontFamily:HEADING,
          letterSpacing:"-0.2px",lineHeight:1.25,
          textDecoration: task.done ? "line-through" : "none",
          flex:1, margin:0
        }}>{task.title}</p>
        <div style={{display:"flex",gap:"8px",alignItems:"center",flexShrink:0}}>
          <span onClick={()=>onEdit(task)} style={{color:G.n500,fontSize:"10px",fontFamily:BODY,cursor:"pointer",fontWeight:"500",whiteSpace:"nowrap"}}
            onMouseEnter={e=>e.target.style.color=G.g500} onMouseLeave={e=>e.target.style.color=G.n500}>Editar</span>
          <span onClick={()=>onDelete(task.id)} style={{color:G.n500,fontSize:"10px",fontFamily:BODY,cursor:"pointer",fontWeight:"500",whiteSpace:"nowrap"}}
            onMouseEnter={e=>e.target.style.color=G.red} onMouseLeave={e=>e.target.style.color=G.n500}>Remover</span>
          <span style={{fontSize:"10px",fontFamily:BODY,fontWeight:"700",color:G.n900,lineHeight:1}}>#{String(i+1).padStart(2,"0")}</span>
        </div>
      </div>

      {/* Row 2: checkbox + chips + ⠿ */}
      <div style={{display:"flex",alignItems:"center",gap:"5px"}}>
        <div style={{display:"flex",flexWrap:"wrap",gap:"5px",alignItems:"center",flex:1}}>
          <div onClick={()=>onToggle(task.id)} className="check-box" style={{
            width:"16px",height:"16px",borderRadius:"5px",flexShrink:0,
            border:`2px solid ${task.done ? G.g500 : G.n300}`,
            background: task.done ? G.g500 : G.white,
            display:"flex",alignItems:"center",justifyContent:"center",
            cursor:"pointer",marginRight:"2px",
            boxShadow: task.done ? `0 2px 8px ${G.glow}` : "none"
          }}>
            {task.done && <svg width="8" height="7" viewBox="0 0 10 8" fill="none"><path d="M1 3.5L3.8 6.5L9 1" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>}
          </div>
          <span style={{background:priBg(task.priority),color:priColor(task.priority),borderRadius:"6px",padding:"2px 6px",fontSize:"10px",fontWeight:"600",fontFamily:BODY}}>● {task.priority}</span>
          <span style={{background:G.n100,color:G.n500,borderRadius:"6px",padding:"2px 6px",fontSize:"10px",fontFamily:BODY}}>{task.category}</span>
          {task.time && <span style={{color:G.n500,fontSize:"10px",fontFamily:BODY}}>⏰ {task.time}</span>}
          {task.recurrence!=="Nenhuma" && <span style={{color:G.n500,fontSize:"10px",fontFamily:BODY}}>↻ {task.recurrence}</span>}
          {task.groupTag && <span style={{color:G.n500,fontSize:"10px",fontFamily:BODY}}>👨‍👩‍👧‍👦 {task.groupTag}</span>}
          {(task.withWhoTags||[]).length>0 && <span style={{color:G.n500,fontSize:"10px",fontFamily:BODY}}>🙋 {(task.withWhoTags||[]).join(", ")}</span>}
          {task.photo && <span style={{color:G.n500,fontSize:"10px",fontFamily:BODY}}>📷</span>}
        </div>
        {onHandleTouchStart && (
          <div onTouchStart={onHandleTouchStart} onTouchMove={onHandleTouchMove} onTouchEnd={onHandleTouchEnd}
            style={{width:"22px",height:"22px",borderRadius:"6px",display:"flex",alignItems:"center",justifyContent:"center",color:G.n900,fontSize:"15px",cursor:"grab",touchAction:"none",userSelect:"none",flexShrink:0,marginLeft:"auto"}}>⠿</div>
        )}
      </div>
    </div>
  );
}

// ─── GENERATE RECURRENCE OCCURRENCES ─────────────────────────────────────────
function generateOccurrences(form) {
  // No recurrence or no dateEnd → single task
  if (form.recurrence === "Nenhuma" || !form.dateEnd || form.dateEnd <= form.date) {
    return [{ ...form, id: form.id || Date.now(), groupId: null }];
  }

  const stepDays = { "Diária":1, "Semanal":7, "Mensal":30 }[form.recurrence] || 1;
  const results = [];
  let cur = new Date(form.date + "T00:00:00");
  const end = new Date(form.dateEnd + "T00:00:00");
  const groupId = form.groupId || Date.now();
  let idx = 0;

  while (cur <= end) {
    const dateStr = cur.toISOString().split("T")[0];
    results.push({
      ...form,
      date: dateStr,
      id: idx === 0 && form.id ? form.id : Date.now() + idx,
      groupId,
      done: false,
    });
    if (form.recurrence === "Mensal") {
      const next = new Date(cur);
      next.setMonth(next.getMonth() + 1);
      cur = next;
    } else {
      cur = new Date(cur.getTime() + stepDays * 864e5);
    }
    idx++;
    if (idx > 365) break; // safety cap
  }
  return results;
}

// ─── VOZ COM IA ──────────────────────────────────────────────────────────────
function parseVoiceCommand(text) {
  const today = new Date();
  const todayStr = localDate(today);
  const lower = text.toLowerCase();

  // Data
  let date = todayStr;
  if (lower.includes("amanhã")) {
    date = localDate(new Date(Date.now()+864e5));
  } else if (lower.includes("depois de amanhã")) {
    date = localDate(new Date(Date.now()+2*864e5));
  } else {
    const dias = ["domingo","segunda","terça","quarta","quinta","sexta","sábado"];
    for (let i=0;i<dias.length;i++){
      if (lower.includes(dias[i])) {
        const target = i;
        const cur = today.getDay();
        let diff = target - cur;
        if (diff<=0) diff += 7;
        date = localDate(new Date(Date.now()+diff*864e5));
        break;
      }
    }
  }

  // Horário (ex: "às 10h", "10:30", "14 horas")
  let time = "";
  const timeMatch = lower.match(/(\d{1,2})[:h](\d{2})?\s*(horas?)?/);
  if (timeMatch) {
    const h = timeMatch[1].padStart(2,"0");
    const m = (timeMatch[2]||"00").padStart(2,"0");
    time = h+":"+m;
  }

  // Prioridade
  let priority = "Média";
  if (lower.includes("prioridade alta") || lower.includes("urgente")) priority = "Alta";
  else if (lower.includes("prioridade baixa")) priority = "Baixa";

  // Categoria
  let category = "🎯 Pessoal";
  if (lower.includes("trabalho") || lower.includes("reunião") || lower.includes("reuniao")) category = "💼 Trabalho";
  else if (lower.includes("casa")) category = "🏠 Casa";
  else if (lower.includes("saúde") || lower.includes("saude") || lower.includes("médico") || lower.includes("medico")) category = "🏋️ Saúde";
  else if (lower.includes("estudo") || lower.includes("aula")) category = "📚 Estudos";
  else if (lower.includes("finança") || lower.includes("financa") || lower.includes("pagar") || lower.includes("conta")) category = "💰 Finanças";

  // Com quem (depois de "com")
  let withWhoTags = [];
  const comMatch = text.match(/\bcom\s+([A-ZÀ-Úa-zà-ú][a-zà-ú]+(?:\s+[A-ZÀ-Úa-zà-ú][a-zà-ú]+)?)/);
  if (comMatch) withWhoTags = [comMatch[1]];

  // Título: remove palavras de data/hora/prioridade para limpar
  let title = text
    .replace(/\bamanhã\b/gi,"")
    .replace(/\bhoje\b/gi,"")
    .replace(/\bàs?\s*\d{1,2}[:h]\d{0,2}\s*(horas?)?/gi,"")
    .replace(/\bprioridade\s+(alta|média|media|baixa)/gi,"")
    .replace(/\s+/g," ")
    .trim();
  if (!title) title = text;
  // capitaliza primeira letra
  title = title.charAt(0).toUpperCase()+title.slice(1);

  return {
    title, date, time, dateEnd:"", timeEnd:"",
    priority, category, recurrence:"Nenhuma",
    notes:"", withWhoTags, done:false, photo:null, groupId:null
  };
}

function useVoiceTask(onResult) {
  const [listening, setListening] = useState(false);
  const [transcript, setTranscript] = useState("");
  const [processing, setProcessing] = useState(false);
  const [voiceError, setVoiceError] = useState("");

  const start = () => {
    setVoiceError("");
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) {
      setVoiceError("Seu navegador não suporta reconhecimento de voz. Use o Chrome.");
      return;
    }
    let rec;
    try {
      rec = new SR();
    } catch(e) {
      setVoiceError("Não foi possível iniciar o microfone.");
      return;
    }
    rec.lang = "pt-BR";
    rec.interimResults = false;
    rec.maxAlternatives = 1;

    rec.onstart = () => { setListening(true); setTranscript(""); };

    rec.onresult = (e) => {
      const text = e.results[0][0].transcript;
      setTranscript(text);
      setListening(false);
      setProcessing(true);
      setTimeout(() => {
        const parsed = parseVoiceCommand(text);
        onResult(parsed);
        setProcessing(false);
      }, 400);
    };

    rec.onerror = (e) => {
      setListening(false);
      setProcessing(false);
      if (e.error === "not-allowed" || e.error === "permission-denied") {
        setVoiceError("Permissão de microfone negada. Habilite nas configurações do navegador.");
      } else if (e.error === "no-speech") {
        setVoiceError("Não ouvi nada. Tente novamente.");
      } else {
        setVoiceError("Erro no reconhecimento de voz: "+e.error);
      }
    };
    rec.onend = () => { setListening(false); };

    try {
      rec.start();
    } catch(e) {
      setVoiceError("Erro ao iniciar microfone.");
    }
  };

  return { start, listening, processing, transcript, voiceError };
}

// ─── VOICE BUTTON ────────────────────────────────────────────────────────────
function VoiceBtn({ onResult }) {
  const { start, listening, processing, transcript, voiceError } = useVoiceTask(onResult);
  return (
    <>
      {/* Overlay de feedback */}
      {(listening||processing) && (
        <div style={{position:"fixed",inset:0,zIndex:500,background:"rgba(0,0,0,.7)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:"20px"}}>
          <div style={{
            width:"90px",height:"90px",borderRadius:"50%",
            background:listening?G.red:G.amber,
            display:"flex",alignItems:"center",justifyContent:"center",
            fontSize:"40px",
            boxShadow:listening?`0 0 0 16px ${G.red}33, 0 0 0 32px ${G.red}18`:"none",
            animation:listening?"pulse2 1s ease-in-out infinite":"none"
          }}>
            {processing?"⏳":"🎤"}
          </div>
          <div style={{textAlign:"center"}}>
            <p style={{color:"#fff",fontFamily:HEADING,fontSize:"20px",fontWeight:"700",marginBottom:"8px"}}>
              {processing?"Analisando…":"Ouvindo…"}
            </p>
            <p style={{color:"rgba(255,255,255,.7)",fontFamily:BODY,fontSize:"14px",maxWidth:"280px",lineHeight:1.5}}>
              {processing
                ? transcript
                : "Fale sua tarefa. Ex: Reunião com João amanhã às 10h, prioridade alta"}
            </p>
          </div>
          {listening && (
            <div style={{display:"flex",gap:"4px",alignItems:"flex-end",height:"32px"}}>
              {[1,2,3,4,5].map(i=>(
                <div key={i} style={{
                  width:"6px",borderRadius:"3px",background:"#fff",
                  height:`${12+Math.random()*20}px`,
                  animation:`pulse2 ${0.4+i*0.1}s ease-in-out infinite alternate`
                }}/>
              ))}
            </div>
          )}
        </div>
      )}
      {/* Erro de voz */}
      {voiceError && (
        <div style={{position:"fixed",bottom:"24px",left:"50%",transform:"translateX(-50%)",zIndex:600,background:G.red,color:"#fff",padding:"12px 18px",borderRadius:"12px",fontSize:"13px",fontFamily:BODY,maxWidth:"320px",textAlign:"center",boxShadow:"0 8px 24px rgba(0,0,0,.3)"}}>
          ⚠️ {voiceError}
        </div>
      )}
      <button onClick={start} title="Criar tarefa por voz" style={{
        width:"38px",height:"38px",borderRadius:"50%",
        border:`1.5px solid ${listening?G.red:processing?G.amber:G.g500}`,
        background:listening?G.red:processing?G.amber:G.g50,
        cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",
        fontSize:"18px",transition:"all .2s",flexShrink:0
      }}>
        {processing ? "⏳" : listening ? "🎙️" : "🎤"}
      </button>
    </>
  );
}

// ─── GROUP MODAL ─────────────────────────────────────────────────────────────
function GroupModal({ onClose }) {
  const [groups, setGroups]       = useState(LS.get("dr_groups")||[]);
  const [editIdx, setEditIdx]     = useState(null); // null=lista, number=editando
  const [grpName, setGrpName]     = useState("");
  const [members, setMembers]     = useState([]);
  const [memberInput, setMemberInput] = useState("");
  const [nameErr, setNameErr]     = useState(false);

  const inputStyle = {
    flex:1, boxSizing:"border-box", background:G.n50,
    border:`1.5px solid ${G.n500}`, borderRadius:"10px",
    padding:"9px 12px", color:G.n900, fontSize:"13px",
    fontFamily:BODY, outline:"none", width:"100%"
  };

  const addMember = () => {
    const v = memberInput.trim().toUpperCase();
    if (!v || members.includes(v)) return;
    setMembers(m => [...m, v]);
    setMemberInput("");
  };

  const saveGroup = () => {
    const name = grpName.trim().toUpperCase();
    if (!name) { setNameErr(true); return; }
    const updated = [...groups];
    if (editIdx !== null) {
      updated[editIdx] = { name, members };
    } else {
      const exists = updated.findIndex(g => g.name === name);
      if (exists >= 0) updated[exists] = { name, members };
      else updated.push({ name, members });
    }
    LS.set("dr_groups", updated);
    setGroups(updated);
    setEditIdx(null); setGrpName(""); setMembers([]); setNameErr(false);
  };

  const deleteGroup = (idx) => {
    const updated = groups.filter((_,i) => i !== idx);
    LS.set("dr_groups", updated);
    setGroups(updated);
  };

  const startEdit = (idx) => {
    setEditIdx(idx);
    setGrpName(groups[idx].name);
    setMembers([...(groups[idx].members||[])]);
    setNameErr(false);
  };

  return (
    <div style={{position:"fixed",inset:0,zIndex:400,background:"rgba(15,23,42,.5)",backdropFilter:"blur(6px)",display:"flex",alignItems:"flex-end",justifyContent:"center"}} onClick={onClose}>
      <div style={{width:"100%",maxWidth:"480px",maxHeight:"88vh",overflowY:"auto",background:G.white,borderRadius:"24px 24px 0 0",padding:"0 0 32px",boxShadow:"0 -8px 40px rgba(0,0,0,.2)"}} onClick={e=>e.stopPropagation()}>

        {/* Handle */}
        <div style={{display:"flex",justifyContent:"center",padding:"12px 0 8px"}}>
          <div style={{width:"40px",height:"4px",borderRadius:"2px",background:G.n200}}/>
        </div>

        {/* Header */}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"0 20px 2px",borderBottom:`1px solid ${G.n100}`}}>
          <div style={{display:"flex",alignItems:"center",gap:"8px"}}>
            {editIdx !== null && (
              <button onClick={()=>{setEditIdx(null);setGrpName("");setMembers([]);}} style={{background:"none",border:"none",cursor:"pointer",fontSize:"18px",color:G.n500,padding:"0 4px"}}>←</button>
            )}
            <h2 style={{fontFamily:HEADING,fontSize:"18px",fontWeight:"800",color:G.n900,margin:0}}>
              {editIdx !== null ? (editIdx === groups.length ? "Novo Grupo" : "Editar Grupo") : "Meus Grupos"}
            </h2>
          </div>
          <button onClick={onClose} style={{width:"32px",height:"32px",borderRadius:"50%",border:`1px solid ${G.n200}`,background:G.n50,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",color:G.n500,fontSize:"16px",fontFamily:BODY}}>×</button>
        </div>

        <div style={{padding:"16px 20px",display:"flex",flexDirection:"column",gap:"14px"}}>

          {/* ── LISTA DE GRUPOS ── */}
          {editIdx === null && (
            <>
              {groups.length === 0 && (
                <div style={{textAlign:"center",padding:"24px 0"}}>
                  <div style={{fontSize:"32px",marginBottom:"8px"}}>🤝</div>
                  <p style={{color:G.n500,fontFamily:BODY,fontSize:"13px"}}>Nenhum grupo criado ainda</p>
                </div>
              )}
              {groups.map((g,i) => (
                <div key={i} style={{background:G.n50,border:`1px solid ${G.n200}`,borderRadius:"12px",padding:"12px 14px"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"8px"}}>
                    <p style={{fontFamily:HEADING,fontSize:"14px",fontWeight:"700",color:G.n900,margin:0}}>🤝 {g.name}</p>
                    <div style={{display:"flex",gap:"10px"}}>
                      <span onClick={()=>startEdit(i)} style={{color:G.g500,fontSize:"12px",fontFamily:BODY,fontWeight:"600",cursor:"pointer"}}>Editar</span>
                      <span onClick={()=>deleteGroup(i)} style={{color:G.red,fontSize:"12px",fontFamily:BODY,fontWeight:"600",cursor:"pointer"}}>Excluir</span>
                    </div>
                  </div>
                  <div style={{display:"flex",flexWrap:"wrap",gap:"5px"}}>
                    {(g.members||[]).length === 0
                      ? <span style={{color:G.n400,fontSize:"11px",fontFamily:BODY}}>Sem membros</span>
                      : (g.members||[]).map((m,mi) => (
                          <span key={mi} style={{background:G.g50,border:`1px solid ${G.g200}`,borderRadius:"20px",padding:"3px 10px",fontSize:"11px",fontFamily:BODY,color:G.g700,fontWeight:"500"}}>👤 {m}</span>
                        ))
                    }
                  </div>
                </div>
              ))}
              <button onClick={()=>{setEditIdx(groups.length);setGrpName("");setMembers([]);}} style={{
                width:"100%",background:G.g500,color:G.white,border:"none",borderRadius:"12px",
                padding:"12px",fontSize:"14px",fontWeight:"600",fontFamily:BODY,cursor:"pointer",
                boxShadow:`0 4px 14px ${G.glow}`,display:"flex",alignItems:"center",justifyContent:"center",gap:"8px"
              }}>+ Criar novo grupo</button>
            </>
          )}

          {/* ── CRIAR / EDITAR GRUPO ── */}
          {editIdx !== null && (
            <>
              {/* Nome do grupo */}
              <div>
                <label style={{display:"block",color:G.n900,fontSize:"11px",fontWeight:"700",letterSpacing:"0.7px",textTransform:"uppercase",marginBottom:"4px",fontFamily:BODY}}>
                  Nome do grupo <span style={{color:G.red}}>*</span>
                </label>
                <input value={grpName} onChange={e=>{setGrpName(e.target.value.toUpperCase());setNameErr(false);}}
                  placeholder="Ex: SUPERVISORES"
                  style={{...inputStyle, border:`1.5px solid ${nameErr?G.red:G.n500}`}}
                  onFocus={e=>e.target.style.borderColor=nameErr?G.red:G.g500}
                  onBlur={e=>e.target.style.borderColor=nameErr?G.red:G.n500}
                />
                {nameErr && <p style={{color:G.red,fontSize:"11px",fontFamily:BODY,marginTop:"4px"}}>Nome obrigatório</p>}
              </div>

              {/* Membros */}
              <div>
                <label style={{display:"block",color:G.n900,fontSize:"11px",fontWeight:"700",letterSpacing:"0.7px",textTransform:"uppercase",marginBottom:"4px",fontFamily:BODY}}>
                  Membros
                </label>
                {/* Tags dos membros */}
                {members.length > 0 && (
                  <div style={{display:"flex",flexWrap:"wrap",gap:"6px",marginBottom:"8px"}}>
                    {members.map((m,mi) => (
                      <span key={mi} style={{display:"flex",alignItems:"center",gap:"5px",background:G.g50,border:`1px solid ${G.g200}`,borderRadius:"20px",padding:"4px 6px 4px 10px",fontSize:"12px",fontFamily:BODY,color:G.g700,fontWeight:"500"}}>
                        👤 {m}
                        <button onClick={()=>setMembers(ms=>ms.filter((_,i)=>i!==mi))} style={{width:"16px",height:"16px",borderRadius:"50%",border:"none",background:"rgba(0,0,0,.08)",color:G.g700,fontSize:"11px",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>×</button>
                      </span>
                    ))}
                  </div>
                )}
                {/* Input novo membro */}
                <div style={{display:"flex",gap:"8px"}}>
                  <input value={memberInput} onChange={e=>setMemberInput(e.target.value)}
                    placeholder="Digite o nome e pressione Enter…"
                    onKeyDown={e=>{if(e.key==="Enter"){e.preventDefault();addMember();}}}
                    style={inputStyle}
                    onFocus={e=>e.target.style.borderColor=G.g500}
                    onBlur={e=>e.target.style.borderColor=G.n500}
                  />
                  <button onClick={addMember} style={{width:"36px",height:"36px",borderRadius:"10px",border:"none",background:G.g500,color:G.white,fontSize:"20px",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>+</button>
                </div>
              </div>

              {/* Salvar */}
              <button onClick={saveGroup} style={{
                width:"100%",background:G.g500,color:G.white,border:"none",borderRadius:"12px",
                padding:"12px",fontSize:"14px",fontWeight:"600",fontFamily:BODY,cursor:"pointer",
                boxShadow:`0 4px 14px ${G.glow}`,marginTop:"4px"
              }}>Salvar grupo</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── CHIPS BLOCK ─────────────────────────────────────────────────────────────
function ChipsBlock({ form, set }) {
  const [openChip,   setOpenChip]   = useState(null);
  const [groupModal, setGroupModal] = useState(false);
  const [groups,     setGroups]     = useState(LS.get("dr_groups")||[]);

  // Atualiza lista de grupos quando o modal fecha
  const closeGroupModal = () => {
    setGroups(LS.get("dr_groups")||[]);
    setGroupModal(false);
  };

  const priColor2 = { Alta:G.red, Média:G.amber, Baixa:G.g500 };

  const chipStyle = (active) => ({
    flex:"1", display:"flex", flexDirection:"column", alignItems:"center",
    justifyContent:"center", gap:"4px", padding:"10px 4px",
    background: active ? G.g50 : G.white,
    border:`1.5px solid ${active ? G.g500 : G.n500}`,
    borderRadius:"12px", cursor:"pointer", transition:"all .15s",
    boxShadow: active ? `0 2px 10px ${G.glow}` : "none"
  });

  const addWithWho = (inputId) => {
    const el = document.getElementById(inputId);
    const v = el.value.trim().toUpperCase();
    if (v) { set("withWhoTags", [...(form.withWhoTags||[]), v]); el.value=""; }
  };

  return (
    <div>
      {/* Modal de Grupos */}
      {groupModal && <GroupModal onClose={closeGroupModal}/>}

      {/* 4 chips lado a lado */}
      <div style={{display:"flex",gap:"8px",marginBottom:"12px"}}>

        {/* 🏷️ Categoria */}
        <button onClick={()=>setOpenChip(openChip==="cat"?null:"cat")} style={chipStyle(openChip==="cat")}>
          <span style={{fontSize:"18px"}}>🏷️</span>
          <span style={{fontSize:"10px",fontWeight:"600",fontFamily:BODY,color:openChip==="cat"?G.g700:G.n500,lineHeight:1,textAlign:"center"}}>Categoria</span>
          {form.category && <span style={{fontSize:"9px",color:G.g500,fontFamily:BODY,fontWeight:"700",textAlign:"center",lineHeight:1,whiteSpace:"nowrap",overflow:"hidden",maxWidth:"100%"}}>{form.category.split(" ").slice(1).join(" ")||form.category}</span>}
        </button>

        {/* 🎯 Prioridade */}
        <button onClick={()=>setOpenChip(openChip==="pri"?null:"pri")} style={chipStyle(openChip==="pri")}>
          <span style={{fontSize:"18px"}}>🎯</span>
          <span style={{fontSize:"10px",fontWeight:"600",fontFamily:BODY,color:openChip==="pri"?G.g700:G.n500,lineHeight:1,textAlign:"center"}}>Prioridade</span>
          {form.priority && <span style={{fontSize:"9px",color:priColor2[form.priority],fontFamily:BODY,fontWeight:"700",lineHeight:1}}>● {form.priority}</span>}
        </button>

        {/* 🏘️ Grupo */}
        <button onClick={()=>setOpenChip(openChip==="grp"?null:"grp")} style={chipStyle(openChip==="grp" || !!form.groupTag)}>
          <span style={{fontSize:"18px"}}>🤝</span>
          <span style={{fontSize:"10px",fontWeight:"600",fontFamily:BODY,color:(openChip==="grp"||form.groupTag)?G.g700:G.n500,lineHeight:1,textAlign:"center"}}>Grupo</span>
          {form.groupTag && (
            <div style={{display:"flex",alignItems:"center",gap:"2px"}}>
              <span style={{fontSize:"9px",color:G.g500,fontFamily:BODY,fontWeight:"700",lineHeight:1,maxWidth:"52px",overflow:"hidden",whiteSpace:"nowrap"}}>{form.groupTag}</span>
              <span onClick={e=>{e.stopPropagation();set("groupTag","");set("groupMembers",[]);}} style={{fontSize:"11px",color:G.n400,cursor:"pointer",lineHeight:1}}>×</span>
            </div>
          )}
        </button>

        {/* 🙋 Com quem */}
        <button onClick={()=>setOpenChip(openChip==="who"?null:"who")} style={chipStyle(openChip==="who")}>
          <span style={{fontSize:"18px"}}>🙋</span>
          <span style={{fontSize:"10px",fontWeight:"600",fontFamily:BODY,color:openChip==="who"?G.g700:G.n500,lineHeight:1,textAlign:"center"}}>Com quem</span>
          {(form.withWhoTags||[]).length>0 && <span style={{fontSize:"9px",color:G.g500,fontFamily:BODY,fontWeight:"700",lineHeight:1}}>{(form.withWhoTags||[]).length} pessoa{(form.withWhoTags||[]).length>1?"s":""}</span>}
        </button>
      </div>

      {/* Dropdown Categoria */}
      {openChip==="cat" && (
        <div style={{background:G.white,border:`1.5px solid ${G.g200}`,borderRadius:"12px",padding:"12px",marginBottom:"8px"}}>
          <div style={{display:"flex",flexWrap:"wrap",gap:"7px"}}>
            {CATS.map(c=>(
              <button key={c} onClick={()=>{set("category",c);setOpenChip(null);}} style={{
                background:form.category===c?G.g500:G.n100, color:form.category===c?G.white:G.n700,
                border:"none", borderRadius:"20px", padding:"6px 12px",
                fontSize:"12px", fontWeight:"500", fontFamily:BODY, cursor:"pointer", transition:"all .15s"
              }}>{c}</button>
            ))}
          </div>
        </div>
      )}

      {/* Dropdown Prioridade */}
      {openChip==="pri" && (
        <div style={{background:G.white,border:`1.5px solid ${G.g200}`,borderRadius:"12px",padding:"12px",marginBottom:"8px"}}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:"8px"}}>
            {PRIS.map((p,i)=>{
              const clr=[G.red,G.amber,G.g500][i];
              const on=form.priority===p;
              return <button key={p} onClick={()=>{set("priority",p);setOpenChip(null);}} style={{
                background:on?clr:G.n100, color:on?G.white:G.n700,
                border:"none", borderRadius:"10px", padding:"10px 6px",
                fontSize:"13px", fontWeight:"600", fontFamily:BODY, cursor:"pointer",
                transition:"all .15s", boxShadow:on?`0 3px 12px ${clr}33`:"none"
              }}>{p}</button>;
            })}
          </div>
        </div>
      )}

      {/* Dropdown Grupo — selecionar + botão para gerenciar */}
      {openChip==="grp" && (
        <div style={{background:G.white,border:`1.5px solid ${G.g200}`,borderRadius:"12px",padding:"12px",marginBottom:"8px"}}>
          {groups.length === 0
            ? <p style={{color:G.n500,fontSize:"12px",fontFamily:BODY,textAlign:"center",marginBottom:"10px"}}>Nenhum grupo cadastrado ainda</p>
            : <div style={{display:"flex",flexDirection:"column",gap:"6px",marginBottom:"10px"}}>
                {groups.map((g,i)=>(
                  <div key={i} onClick={()=>{
                    set("groupTag", g.name);
                    set("groupMembers", g.members||[]);
                    setOpenChip(null);
                  }} style={{
                    display:"flex", justifyContent:"space-between", alignItems:"center",
                    padding:"10px 12px", borderRadius:"10px", cursor:"pointer",
                    background: form.groupTag===g.name ? G.g50 : G.n50,
                    border:`1.5px solid ${form.groupTag===g.name ? G.g500 : G.n500}`,
                    transition:"all .15s"
                  }}>
                    <div>
                      <p style={{fontFamily:BODY,fontSize:"13px",fontWeight:"600",color:G.n900,margin:0}}>🤝 {g.name}</p>
                      <p style={{fontFamily:BODY,fontSize:"11px",color:G.n500,margin:0,marginTop:"2px"}}>{(g.members||[]).length} membro{(g.members||[]).length!==1?"s":""}</p>
                    </div>
                    {form.groupTag===g.name && <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8L6.5 11.5L13 4.5" stroke={G.g500} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>}
                  </div>
                ))}
              </div>
          }
          <button onClick={()=>{setOpenChip(null);setGroupModal(true);}} style={{
            width:"100%", background:G.g50, color:G.g700,
            border:`1.5px solid ${G.g200}`, borderRadius:"10px",
            padding:"9px", fontSize:"13px", fontWeight:"600",
            fontFamily:BODY, cursor:"pointer"
          }}>⚙️ Gerenciar grupos</button>
        </div>
      )}

      {/* Dropdown Com quem — independente do grupo */}
      {openChip==="who" && (
        <div style={{background:G.white,border:`1.5px solid ${G.g200}`,borderRadius:"12px",padding:"12px",marginBottom:"8px"}}>
          {(form.withWhoTags||[]).length > 0 && (
            <div style={{display:"flex",flexWrap:"wrap",gap:"6px",marginBottom:"8px"}}>
              {(form.withWhoTags||[]).map((tag,idx)=>(
                <span key={idx} style={{display:"flex",alignItems:"center",gap:"5px",background:G.g50,border:`1px solid ${G.g200}`,borderRadius:"20px",padding:"4px 6px 4px 10px",fontSize:"12px",fontFamily:BODY,color:G.g700,fontWeight:"500"}}>
                  👤 {tag}
                  <button onClick={()=>set("withWhoTags",(form.withWhoTags||[]).filter((_,i)=>i!==idx))} style={{width:"16px",height:"16px",borderRadius:"50%",border:"none",background:"rgba(0,0,0,.08)",color:G.g700,fontSize:"11px",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>×</button>
                </span>
              ))}
            </div>
          )}
          <div style={{display:"flex",gap:"8px"}}>
            <input id="withWhoInput" placeholder="Nome (Enter para adicionar)…"
              onKeyDown={e=>{if(e.key==="Enter"){e.preventDefault();addWithWho("withWhoInput");}}}
              style={{flex:1,boxSizing:"border-box",background:G.n50,border:`1.5px solid ${G.n200}`,borderRadius:"10px",padding:"8px 12px",color:G.n900,fontSize:"13px",fontFamily:BODY,outline:"none"}}
              onFocus={e=>e.target.style.borderColor=G.g500} onBlur={e=>e.target.style.borderColor=G.n500}
            />
            <button onClick={()=>addWithWho("withWhoInput")} style={{width:"36px",height:"36px",borderRadius:"10px",border:"none",background:G.g500,color:G.white,fontSize:"20px",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>+</button>
          </div>
        </div>
      )}

      {/* Membros do grupo selecionado — X remove só da tarefa, não do grupo */}
      {form.groupTag && (form.groupMembers||[]).length > 0 && (
        <div style={{background:G.g50,border:`1px solid ${G.g200}`,borderRadius:"10px",padding:"10px 12px",marginBottom:"8px"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"6px"}}>
            <p style={{fontFamily:BODY,fontSize:"11px",fontWeight:"600",color:G.g700,textTransform:"uppercase",letterSpacing:"0.5px",margin:0}}>Membros de {form.groupTag}</p>
            <span style={{fontFamily:BODY,fontSize:"10px",color:G.n400}}>× remove da tarefa</span>
          </div>
          <div style={{display:"flex",flexWrap:"wrap",gap:"5px"}}>
            {(form.groupMembers||[]).map((m,i)=>(
              <span key={i} style={{display:"flex",alignItems:"center",gap:"4px",background:G.white,border:`1px solid ${G.g200}`,borderRadius:"20px",padding:"3px 6px 3px 10px",fontSize:"11px",fontFamily:BODY,color:G.g700}}>
                👤 {m}
                <button onClick={()=>set("groupMembers",(form.groupMembers||[]).filter((_,j)=>j!==i))} style={{width:"14px",height:"14px",borderRadius:"50%",border:"none",background:"rgba(0,0,0,.08)",color:G.n500,fontSize:"10px",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,lineHeight:1}}>×</button>
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

// ─── MODAL ────────────────────────────────────────────────────────────────────
function TaskModal({ task, onSave, onClose }) {
  const td = localDate();
  const [form, setForm] = useState(task ? {...task, dateEnd:task.dateEnd||"", timeEnd:task.timeEnd||"", withWhoTags:task.withWhoTags||(task.withWho?[task.withWho]:[]), groupTag:task.groupTag||"", groupMembers:task.groupMembers||[]} : {title:"",category:CATS[0],date:"",dateEnd:"",time:"",timeEnd:"",priority:"Média",recurrence:"Nenhuma",notes:"",withWhoTags:[],groupTag:"",groupMembers:[],photo:null,done:false,groupId:null});
  const [errors, setErrors] = useState(false);
  const previewCount = (() => { if(form.recurrence==="Nenhuma"||!form.dateEnd||form.dateEnd<=form.date) return 1; return generateOccurrences(form).length; })();
  const fileRef = useRef();
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  // também adicionar timeEnd ao form inicial


  return (
    <div style={{position:"fixed",inset:0,zIndex:200,background:"rgba(15,23,42,.4)",backdropFilter:"blur(8px)",display:"flex",alignItems:"flex-end",justifyContent:"center"}} onClick={onClose}>
      <div onClick={e=>e.stopPropagation()} className="slide-up" style={{
        width:"100%",maxWidth:"480px",maxHeight:"94vh",overflowY:"auto",overflowX:"hidden",
        background:G.g50,borderRadius:"24px 24px 0 0",padding:"0 0 36px",boxSizing:"border-box",
        boxShadow:"0 -12px 60px rgba(0,0,0,.15)"
      }}>
        {/* handle */}
        <div style={{display:"flex",justifyContent:"center",padding:"14px 0 0"}}>
          <div style={{width:"32px",height:"4px",borderRadius:"2px",background:G.n200}}/>
        </div>

        {/* header */}
        <div style={{padding:"16px 24px 18px",borderBottom:`1px solid ${G.n100}`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <p style={{color:G.g500,fontSize:"11px",fontWeight:"600",letterSpacing:"1px",textTransform:"uppercase",fontFamily:BODY,marginBottom:"2px"}}>
              {task ? "Modificar" : "Nova tarefa"}
            </p>
            <h2 style={{fontFamily:HEADING,fontSize:"20px",fontWeight:"800",color:G.n900,letterSpacing:"-0.5px"}}>
              {task ? "Editar Tarefa" : "Criar Tarefa"}
            </h2>
          </div>
          <div style={{display:"flex",gap:"8px",alignItems:"center"}}>
            <VoiceBtn onResult={v=>{ Object.entries(v).forEach(([k,val])=>set(k,val)); }} />
            <button onClick={onClose} style={{width:"34px",height:"34px",borderRadius:"50%",border:`1px solid ${G.n200}`,background:G.n50,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",color:G.n500,fontSize:"18px",fontFamily:BODY}}>×</button>
          </div>
        </div>

        <div style={{padding:"10px 14px",display:"flex",flexDirection:"column",gap:"6px",width:"100%",boxSizing:"border-box",minWidth:0}}>

          {/* Título — obrigatório */}
          <div>
            <label style={{display:"block",color:G.n900,fontSize:"11px",fontWeight:"700",letterSpacing:"0.7px",textTransform:"uppercase",marginBottom:"4px",fontFamily:BODY}}>
              Título <span style={{color:G.red}}>*</span>
            </label>
            <input value={form.title} onChange={e=>set("title",e.target.value)} placeholder="Descreva a tarefa…"
              style={{width:"100%",background:G.white,border:`1.5px solid ${errors&&!form.title?G.red:G.n500}`,borderRadius:"10px",padding:"8px 14px",color:G.n900,fontSize:"14px",fontFamily:HEADING,fontWeight:"600",outline:"none",transition:"border-color .18s"}}
              onFocus={e=>{e.target.style.borderColor=G.g500;e.target.style.boxShadow=`0 0 0 3px ${G.glow}`}}
              onBlur={e=>{e.target.style.borderColor=(!form.title&&errors)?G.red:G.n500;e.target.style.boxShadow="none"}}
            />
            {errors&&!form.title&&<p style={{color:G.red,fontSize:"11px",fontFamily:BODY,marginTop:"4px"}}>Campo obrigatório</p>}
          </div>

          {/* Data início + Horário início */}
          <div style={{display:"flex",justifyContent:"space-between",width:"100%",boxSizing:"border-box"}}>
            <div style={{width:"48%"}}>
              <label style={{display:"block",color:G.n900,fontSize:"11px",fontWeight:"700",letterSpacing:"0.5px",textTransform:"uppercase",marginBottom:"4px",fontFamily:BODY}}>
                Data início <span style={{color:G.red}}>*</span>
              </label>
              <input value={form.date||""} onChange={e=>set("date",e.target.value)} type="date"
                style={{width:"100%",height:"36px",boxSizing:"border-box",background:G.white,border:`1.5px solid ${errors&&!form.date?G.red:G.n500}`,borderRadius:"10px",padding:"0 8px",color:G.n900,fontSize:"13px",fontFamily:BODY,outline:"none",colorScheme:"light"}}
                onFocus={e=>e.target.style.borderColor=G.g500} onBlur={e=>e.target.style.borderColor=(!form.date&&errors)?G.red:G.n500}
              />
              {errors&&!form.date&&<p style={{color:G.red,fontSize:"11px",fontFamily:BODY,marginTop:"4px"}}>Obrigatório</p>}
            </div>
            <div style={{width:"48%"}}>
              <label style={{display:"block",color:G.n900,fontSize:"11px",fontWeight:"700",letterSpacing:"0.5px",textTransform:"uppercase",marginBottom:"4px",fontFamily:BODY}}>Hora</label>
              <input value={form.time||""} onChange={e=>set("time",e.target.value)} type="time"
                style={{width:"100%",height:"36px",boxSizing:"border-box",background:G.white,border:`1.5px solid ${G.n500}`,borderRadius:"10px",padding:"0 8px",color:G.n900,fontSize:"13px",fontFamily:BODY,outline:"none",colorScheme:"light"}}
                onFocus={e=>e.target.style.borderColor=G.g500} onBlur={e=>e.target.style.borderColor=G.n500}
              />
            </div>
          </div>

          {/* Data final + Horário final */}
          <div style={{display:"flex",justifyContent:"space-between",width:"100%",boxSizing:"border-box"}}>
            <div style={{width:"48%"}}>
              <label style={{display:"block",color:G.n900,fontSize:"11px",fontWeight:"700",letterSpacing:"0.5px",textTransform:"uppercase",marginBottom:"4px",fontFamily:BODY}}>Data final</label>
              <input value={form.dateEnd||""} onChange={e=>set("dateEnd",e.target.value)} type="date"
                style={{width:"100%",height:"36px",boxSizing:"border-box",background:G.white,border:`1.5px solid ${G.n500}`,borderRadius:"10px",padding:"0 8px",color:G.n900,fontSize:"13px",fontFamily:BODY,outline:"none",colorScheme:"light"}}
                onFocus={e=>e.target.style.borderColor=G.g500} onBlur={e=>e.target.style.borderColor=G.n500}
              />
            </div>
            <div style={{width:"48%"}}>
              <label style={{display:"block",color:G.n900,fontSize:"11px",fontWeight:"700",letterSpacing:"0.5px",textTransform:"uppercase",marginBottom:"4px",fontFamily:BODY}}>Hora final</label>
              <input value={form.timeEnd||""} onChange={e=>set("timeEnd",e.target.value)} type="time"
                style={{width:"100%",height:"36px",boxSizing:"border-box",background:G.white,border:`1.5px solid ${G.n500}`,borderRadius:"10px",padding:"0 8px",color:G.n900,fontSize:"13px",fontFamily:BODY,outline:"none",colorScheme:"light"}}
                onFocus={e=>e.target.style.borderColor=G.g500} onBlur={e=>e.target.style.borderColor=G.n500}
              />
            </div>
          </div>

          {/* Recurrence */}
          <div>
            <label style={{display:"block",color:G.n900,fontSize:"11px",fontWeight:"700",letterSpacing:"0.7px",textTransform:"uppercase",marginBottom:"5px",fontFamily:BODY}}>Recorrência</label>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:"6px"}}>
              {RECS.map(r=>(
                <button key={r} onClick={()=>set("recurrence",r)} style={{
                  background: form.recurrence===r ? G.g100 : G.n100,
                  color: form.recurrence===r ? G.g700 : G.n500,
                  border: `1.5px solid ${form.recurrence===r ? G.g400 : G.n500}`,
                  borderRadius:"9px", padding:"6px 2px", fontSize:"11px",
                  fontWeight:"600", fontFamily:BODY, cursor:"pointer", transition:"all .15s"
                }}>{r}</button>
              ))}
            </div>
          </div>

          {/* Preview recorrência */}
          {form.recurrence !== "Nenhuma" && form.dateEnd && form.dateEnd > form.date && (
            <div style={{background:G.g50,border:`1px solid ${G.g200}`,borderRadius:"8px",padding:"10px 12px",display:"flex",alignItems:"center",gap:"8px"}}>
              <span style={{fontSize:"14px"}}>📅</span>
              <p style={{color:G.g700,fontFamily:BODY,fontSize:"12px",fontWeight:"500"}}>
                Serão criadas <strong>{previewCount} ocorrências</strong> de "{form.title||"esta tarefa"}" ({form.recurrence.toLowerCase()})
              </p>
            </div>
          )}

          {/* Photo */}
          <div>
            <label style={{display:"block",color:G.n900,fontSize:"11px",fontWeight:"700",letterSpacing:"0.7px",textTransform:"uppercase",marginBottom:"5px",fontFamily:BODY}}>Foto</label>
            <input ref={fileRef} type="file" accept="image/*" style={{display:"none"}} onChange={e=>{
              const f=e.target.files[0]; if(!f) return;
              const r=new FileReader(); r.onload=ev=>set("photo",ev.target.result); r.readAsDataURL(f);
            }}/>
            <button onClick={()=>fileRef.current.click()} style={{
              width:"100%", background:G.n50, border:`1.5px solid ${G.n500}`,
              borderRadius:"10px", padding:"8px", color:G.n500, fontFamily:BODY,
              fontSize:"13px", cursor:"pointer", transition:"border-color .2s, color .2s"
            }}
              onMouseEnter={e=>{e.currentTarget.style.borderColor=G.g400;e.currentTarget.style.color=G.g500;}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor=G.n500;e.currentTarget.style.color=G.n500;}}
            >{form.photo ? "📷  Foto anexada ✓" : "📷  Adicionar foto"}</button>
            {form.photo && <img src={form.photo} alt="" style={{width:"100%",borderRadius:"10px",marginTop:"8px",maxHeight:"150px",objectFit:"cover"}}/>}
          </div>

          {/* ── BLOCO 4 CHIPS ─────────────────────────────────── */}
          <ChipsBlock form={form} set={set}/>

          {/* Anotações 80% + SALVAR 20% */}
          <div>
            <label style={{display:"block",color:G.n900,fontSize:"11px",fontWeight:"700",letterSpacing:"0.7px",textTransform:"uppercase",marginBottom:"4px",fontFamily:BODY}}>Anotações</label>
            <div style={{display:"flex",gap:"8px",alignItems:"stretch"}}>
              <input value={form.notes||""} onChange={e=>set("notes",e.target.value)} placeholder="Detalhes opcionais…"
                style={{flex:"0 0 78%",boxSizing:"border-box",background:G.white,border:`1.5px solid ${G.n500}`,borderRadius:"10px",padding:"8px 12px",color:G.n900,fontSize:"13px",fontFamily:BODY,outline:"none",transition:"border-color .18s"}}
                onFocus={e=>e.target.style.borderColor=G.g500} onBlur={e=>e.target.style.borderColor=G.n500}
              />
              <button onClick={()=>{
                if(!form.title||!form.date){ setErrors(true); return; }
                const occurrences = generateOccurrences({...form, id:form.id||Date.now()});
                onSave(occurrences);
                onClose();
              }} style={{
                flex:"1", background:G.g500, color:G.white, border:"none",
                borderRadius:"10px", fontSize:"13px", fontWeight:"700",
                fontFamily:BODY, cursor:"pointer",
                boxShadow:`0 4px 14px ${G.glow}`, transition:"background .18s",
                whiteSpace:"nowrap", padding:"0 8px"
              }}
                onMouseEnter={e=>e.currentTarget.style.background=G.g700}
                onMouseLeave={e=>e.currentTarget.style.background=G.g500}
              >SALVAR</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── REPORTS ─────────────────────────────────────────────────────────────────
function BarChart({ tasks }) {
  const [range, setRange] = useState(7);
  const days = Array.from({length:range}, (_,i)=>{
    const d = new Date(Date.now() - i*864e5);
    const key = localDate(d);
    const label = d.toLocaleDateString("pt-BR",{weekday:"short",day:"2-digit"}).replace(".","·");
    const done  = tasks.filter(t=>t.date===key&&t.done).length;
    const total = tasks.filter(t=>t.date===key).length;
    const late  = key < tod() ? tasks.filter(t=>t.date===key&&!t.done).length : 0;
    const pend  = key >= tod() ? total-done : 0;
    return {key,label,done,pend,late,total};
  });
  const maxVal = Math.max(...days.map(d=>d.total), 1);
  const BAR_H = 120;

  return (
    <div className="fade-up" style={{animationDelay:".36s",background:G.white,border:`1px solid ${G.n200}`,borderRadius:"18px",padding:"20px",marginBottom:"12px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"18px"}}>
        <h3 style={{fontFamily:HEADING,fontSize:"14px",fontWeight:"700",color:G.n900}}>Tarefas</h3>
        <div style={{display:"flex",gap:"4px",background:G.n100,borderRadius:"8px",padding:"3px"}}>
          {[7,14,30].map(r=>(
            <button key={r} onClick={()=>setRange(r)} style={{
              background:range===r?G.g500:"transparent",
              color:range===r?G.white:G.n500,
              border:"none",borderRadius:"6px",padding:"4px 10px",
              fontSize:"11px",fontWeight:"600",fontFamily:BODY,cursor:"pointer",transition:"all .15s"
            }}>{r}d</button>
          ))}
        </div>
      </div>

      {/* bars */}
      <div style={{display:"flex",alignItems:"flex-end",gap:range<=7?"6px":"4px",height:`${BAR_H+28}px`,overflowX:range>7?"auto":"visible",paddingBottom:"4px"}}>
        {days.map((d,i)=>{
            const isToday = d.key===tod();
          return (
            <div key={d.key} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:"4px",flex:range<=7?"1":"0 0 auto",minWidth:range<=7?"0":`${Math.max(100/Math.min(range,10),8)}%`}}>
              {/* tooltip on hover handled via title */}
              {(()=>{
                const pendH = d.pend>0 ? Math.max(Math.round((d.pend/maxVal)*BAR_H),18) : 0;
                const lateH = d.late>0 ? Math.max(Math.round((d.late/maxVal)*BAR_H),18) : 0;
                const doneH = d.done>0 ? Math.max(Math.round((d.done/maxVal)*BAR_H),18) : 0;
                const lblStyle = {position:"absolute",left:0,right:0,textAlign:"center",color:"rgba(0,0,0,.55)",fontSize:"9px",fontWeight:"700",fontFamily:"Inter,sans-serif",lineHeight:1,pointerEvents:"none"};
                const lblStyleW = {...lblStyle,color:"rgba(255,255,255,.9)"};
                return (
                  <div title={`${d.done} feitas · ${d.pend} pendentes · ${d.late} atrasadas`} style={{display:"flex",flexDirection:"column",justifyContent:"flex-end",height:`${BAR_H}px`,width:"100%",gap:"2px",cursor:"default"}}>
                    {d.pend>0 && <div style={{width:"100%",height:`${pendH}px`,background:G.n200,borderRadius:"4px 4px 0 0",transition:"height .6s ease",position:"relative",display:"flex",alignItems:"center",justifyContent:"center"}}>
                      {pendH>=14 && <span style={lblStyle}>{d.pend}</span>}
                    </div>}
                    {d.late>0 && <div style={{width:"100%",height:`${lateH}px`,background:"#FCA5A5",borderRadius:d.done>0?"0":"4px 4px 0 0",transition:"height .6s ease",position:"relative",display:"flex",alignItems:"center",justifyContent:"center"}}>
                      {lateH>=14 && <span style={lblStyle}>{d.late}</span>}
                    </div>}
                    {d.done>0 && <div style={{width:"100%",height:`${doneH}px`,background:isToday?G.g500:`linear-gradient(180deg,${G.g400},${G.g700})`,borderRadius:(d.pend>0||d.late>0)?"0":"4px 4px 0 0",transition:"height .6s ease",boxShadow:isToday?`0 2px 8px ${G.glow}`:"none",position:"relative",display:"flex",alignItems:"center",justifyContent:"center"}}>
                      {doneH>=14 && <span style={lblStyleW}>{d.done}</span>}
                    </div>}
                    {d.total===0 && <div style={{width:"100%",height:"3px",background:G.n100,borderRadius:"2px"}}/>}
                  </div>
                );
              })()}
              <span style={{color:G.n900,fontSize:"9px",fontFamily:BODY,fontWeight:isToday?"700":"500",letterSpacing:"0.3px",textAlign:"center",lineHeight:1.2}}>{d.label}</span>
            </div>
          );
        })}
      </div>

      {/* legend */}
      <div style={{display:"flex",gap:"14px",marginTop:"12px",paddingTop:"12px",borderTop:`1px solid ${G.n200}`}}>
        {[{c:G.g500,l:"Concluídas"},{c:G.n200,l:"Pendentes"},{c:"#FCA5A5",l:"Atrasadas"}].map(x=>(
          <div key={x.l} style={{display:"flex",alignItems:"center",gap:"5px"}}>
            <div style={{width:"10px",height:"10px",borderRadius:"2px",background:x.c,flexShrink:0}}/>
            <span style={{color:G.n500,fontSize:"11px",fontFamily:BODY}}>{x.l}</span>
          </div>
        ))}
      </div>
    </div>
  );
}


// ─── RANGE PICKER ────────────────────────────────────────────────────────────
function RangePicker({ dateFrom, dateTo, onRange }) {
  const [open,      setOpen]      = useState(false);
  const [hovered,   setHovered]   = useState(null);
  const [viewYear,  setViewYear]  = useState(new Date().getFullYear());
  const [viewMonth, setViewMonth] = useState(new Date().getMonth());

  const MONTHS = ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"];
  const WEEKDAYS = ["D","S","T","Q","Q","S","S"];

  const toStr = (y,m,d) => `${y}-${String(m+1).padStart(2,"0")}-${String(d).padStart(2,"0")}`;

  const getDays = (year, month) => {
    const first = new Date(year, month, 1).getDay();
    const total = new Date(year, month+1, 0).getDate();
    return { first, total };
  };

  const handleDay = (str) => {
    if (!dateFrom || (dateFrom && dateTo)) {
      // Começa novo range
      onRange(str, "");
    } else {
      // Segundo clique — define fim
      if (str.localeCompare(dateFrom) < 0) onRange(str, dateFrom);
      else onRange(dateFrom, str);
      setOpen(false);
    }
  };

  const inRange = (str) => {
    if (!dateFrom || !dateTo) return false;
    return str.localeCompare(dateFrom) > 0 && str.localeCompare(dateTo) < 0;
  };

  const isStart = (str) => str === dateFrom;
  const isEnd   = (str) => str === dateTo;

  const prevMonth = () => {
    if (viewMonth === 0) { setViewMonth(11); setViewYear(y => y-1); }
    else setViewMonth(m => m-1);
  };
  const nextMonth = () => {
    if (viewMonth === 11) { setViewMonth(0); setViewYear(y => y+1); }
    else setViewMonth(m => m+1);
  };

  const { first, total } = getDays(viewYear, viewMonth);

  const fmtLabel = (d) => {
    if (!d) return null;
    const [y,m,day] = d.split("-");
    return `${day}/${m}/${String(y).slice(2)}`;
  };

  const hasRange = dateFrom || dateTo;

  return (
    <div style={{position:"relative",marginBottom:"8px"}}>
      {/* Botão trigger */}
      <button onClick={()=>setOpen(v=>!v)} style={{
        width:"100%", height:"36px", borderRadius:"10px", cursor:"pointer",
        background: hasRange ? G.g500 : G.white,
        color: hasRange ? G.white : G.n700,
        border:`1.5px solid ${hasRange ? G.g500 : G.g200}`,
        fontSize:"12px", fontWeight:"600", fontFamily:BODY,
        display:"flex", alignItems:"center", justifyContent:"space-between",
        padding:"0 12px", boxSizing:"border-box",
        boxShadow: hasRange ? `0 2px 8px ${G.glow}` : "none"
      }}>
        <span>
          {hasRange
            ? `${fmtLabel(dateFrom)||"?"} → ${fmtLabel(dateTo)||"?"}`
            : "📅 Filtrar por período"}
        </span>
        <div style={{display:"flex",gap:"6px",alignItems:"center"}}>
          {hasRange && (
            <span onClick={e=>{e.stopPropagation();onRange("","");}} style={{
              fontSize:"14px",color:G.white,opacity:.8,cursor:"pointer",lineHeight:1
            }}>×</span>
          )}
          <span style={{fontSize:"9px",opacity:.7}}>{open?"▲":"▼"}</span>
        </div>
      </button>

      {/* Calendário dropdown */}
      {open && (
        <>
          <div onClick={()=>setOpen(false)} style={{position:"fixed",inset:0,zIndex:9998}}/>
          <div style={{
            position:"absolute",top:"42px",left:0,right:0,zIndex:9999,
            background:G.white,borderRadius:"14px",
            border:`1.5px solid ${G.g200}`,
            padding:"12px",
            boxShadow:"0 8px 32px rgba(0,0,0,.2)"
          }}>
            {/* Cabeçalho mês/ano */}
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"10px"}}>
              <button onClick={prevMonth} style={{width:"28px",height:"28px",borderRadius:"8px",border:"none",background:G.n100,color:G.n700,cursor:"pointer",fontSize:"14px",display:"flex",alignItems:"center",justifyContent:"center"}}>‹</button>
              <span style={{fontFamily:HEADING,fontSize:"13px",fontWeight:"700",color:G.n900}}>
                {MONTHS[viewMonth]} {viewYear}
              </span>
              <button onClick={nextMonth} style={{width:"28px",height:"28px",borderRadius:"8px",border:"none",background:G.n100,color:G.n700,cursor:"pointer",fontSize:"14px",display:"flex",alignItems:"center",justifyContent:"center"}}>›</button>
            </div>

            {/* Dias da semana */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:"2px",marginBottom:"4px"}}>
              {WEEKDAYS.map((w,i)=>(
                <div key={i} style={{textAlign:"center",fontSize:"10px",fontFamily:BODY,fontWeight:"600",color:G.n400,padding:"2px 0"}}>{w}</div>
              ))}
            </div>

            {/* Dias do mês */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:"2px"}}>
              {Array.from({length: first}).map((_,i)=><div key={"e"+i}/>)}
              {Array.from({length: total}).map((_,i)=>{
                const d = i+1;
                const str = toStr(viewYear, viewMonth, d);
                const start = isStart(str);
                const end   = isEnd(str);
                const range = inRange(str);
                const hov   = hovered===str && dateFrom && !dateTo;
                const inHov = hovered && dateFrom && !dateTo && str.localeCompare(dateFrom) > 0 && str.localeCompare(hovered) <= 0;
                return (
                  <div key={d}
                    onClick={()=>handleDay(str)}
                    onMouseEnter={()=>setHovered(str)}
                    onMouseLeave={()=>setHovered(null)}
                    style={{
                      textAlign:"center",
                      padding:"5px 0",
                      borderRadius: start||end ? "8px" : range||inHov ? "0" : "8px",
                      background: start||end ? G.g500 : range||inHov ? G.g50 : "transparent",
                      color: start||end ? G.white : G.n900,
                      fontSize:"12px",fontFamily:BODY,fontWeight: start||end ? "700":"400",
                      cursor:"pointer",
                      transition:"background .1s"
                    }}
                  >{d}</div>
                );
              })}
            </div>

            {/* Instrução */}
            <p style={{color:G.n400,fontFamily:BODY,fontSize:"11px",textAlign:"center",marginTop:"10px"}}>
              {!dateFrom ? "Clique para selecionar a data inicial" : !dateTo ? "Clique para selecionar a data final" : "Período selecionado"}
            </p>
          </div>
        </>
      )}
    </div>
  );
}

// ─── REALIZED ────────────────────────────────────────────────────────────────
function Realized({ tasks }) {
  const [dateFrom,    setDateFrom]    = useState("");
  const [dateTo,      setDateTo]      = useState("");
  const [search,      setSearch]      = useState("");
  const [sfocus,      setSfocus]      = useState(false);
  const [grpFilter,   setGrpFilter]   = useState("");
  const [grpDDOpen,   setGrpDDOpen]   = useState(false);
  const [grpDDPos,    setGrpDDPos]    = useState({top:0,left:0});

  const fmtDoneAt = (iso) => {
    if (!iso) return "—";
    const d = new Date(iso);
    return d.toLocaleDateString("pt-BR",{day:"2-digit",month:"2-digit",year:"2-digit"})
      + " " + d.toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"});
  };

  const done = tasks.filter(t => t.done);

  const filtered = done.filter(t => {
    const doneDay = t.doneAt ? t.doneAt.split("T")[0] : null;
    if (dateFrom && doneDay && doneDay < dateFrom) return false;
    if (dateTo   && doneDay && doneDay > dateTo)   return false;
    if (search && !t.title.toLowerCase().includes(search.toLowerCase())) return false;
    if (grpFilter && t.groupTag !== grpFilter) return false;
    return true;
  });

  const sorted = [...filtered].sort((a,b) => {
    if (!a.doneAt && !b.doneAt) return 0;
    if (!a.doneAt) return 1;
    if (!b.doneAt) return -1;
    return b.doneAt.localeCompare(a.doneAt);
  });

  return (
    <div style={{paddingBottom:"110px"}}>

      {/* Calendário range picker */}
      <RangePicker dateFrom={dateFrom} dateTo={dateTo} onRange={(from,to)=>{setDateFrom(from);setDateTo(to);}}/>

      {/* Grupos + Busca — idêntico ao Início */}
      <div style={{display:"flex",gap:"8px",marginBottom:"10px",alignItems:"center",position:"relative",zIndex:200}}>
        <div style={{position:"relative",width:"35%",zIndex:201}}>
          <button onClick={e=>{const r=e.currentTarget.getBoundingClientRect();setGrpDDPos({top:r.bottom+4,left:r.left});setGrpDDOpen(v=>!v);}} style={{
            width:"100%",height:"36px",padding:"0 10px",borderRadius:"10px",cursor:"pointer",
            background:grpFilter?G.g500:G.white,color:grpFilter?G.white:G.n700,
            border:`1.5px solid ${grpFilter?G.g500:G.g200}`,
            fontSize:"12px",fontWeight:"600",fontFamily:BODY,
            display:"flex",alignItems:"center",justifyContent:"space-between",whiteSpace:"nowrap",
            boxShadow:grpFilter?`0 2px 8px ${G.glow}`:"none"
          }}>
            <span>🤝 {grpFilter||"Grupos"}</span>
            <span style={{fontSize:"9px",marginLeft:"4px"}}>{grpDDOpen?"▲":"▼"}</span>
          </button>
        </div>
        <div style={{position:"relative",flex:1,minWidth:0}}>
          <span style={{position:"absolute",left:"10px",top:"50%",transform:"translateY(-50%)",color:sfocus?G.g500:G.n400,fontSize:"13px"}}>⌕</span>
          <input value={search} onChange={e=>setSearch(e.target.value)}
            onFocus={()=>setSfocus(true)} onBlur={()=>setSfocus(false)}
            placeholder="Buscar tarefa…"
            style={{width:"100%",boxSizing:"border-box",background:G.white,border:`1.5px solid ${sfocus?G.g500:G.g200}`,borderRadius:"10px",padding:"8px 10px 8px 28px",color:G.n900,fontSize:"13px",fontFamily:BODY,outline:"none",transition:"border-color .18s"}}
          />
        </div>
      </div>

      {/* Dropdown grupos — fora do flow via estado posicional */}
      {grpDDOpen && (
        <>
          <div onClick={()=>setGrpDDOpen(false)} style={{position:"fixed",inset:0,zIndex:9998}}/>
          <div style={{position:"fixed",top:grpDDPos.top,left:grpDDPos.left,zIndex:9999,background:G.white,border:`1.5px solid ${G.g200}`,borderRadius:"12px",padding:"6px",minWidth:"180px",boxShadow:"0 8px 32px rgba(0,0,0,.25)"}}>
            <div onClick={()=>{setGrpFilter("");setGrpDDOpen(false);}} style={{padding:"8px 12px",borderRadius:"8px",cursor:"pointer",background:!grpFilter?G.g50:"transparent",color:!grpFilter?G.g700:G.n700,fontSize:"12px",fontFamily:BODY,fontWeight:!grpFilter?"600":"400"}}>
              🔍 Todos os grupos
            </div>
            {(LS.get("dr_groups")||[]).length===0
              ? <p style={{color:G.n400,fontSize:"11px",fontFamily:BODY,padding:"6px 12px"}}>Nenhum grupo cadastrado</p>
              : (LS.get("dr_groups")||[]).map((g,gi)=>(
                <div key={gi} onClick={()=>{setGrpFilter(g.name);setGrpDDOpen(false);}} style={{padding:"8px 12px",borderRadius:"8px",cursor:"pointer",background:grpFilter===g.name?G.g50:"transparent",color:grpFilter===g.name?G.g700:G.n700,fontSize:"11px",fontFamily:BODY,fontWeight:grpFilter===g.name?"600":"400",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span>🤝 {g.name}</span>
                  <span style={{fontSize:"10px",color:G.n400,marginLeft:"8px"}}>{(g.members||[]).length}m</span>
                </div>
              ))
            }
          </div>
        </>
      )}

      {/* Contador */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"10px"}}>
        <span style={{color:G.white,fontFamily:BODY,fontSize:"12px",fontWeight:"600",opacity:.8}}>
          {sorted.length} tarefa{sorted.length!==1?"s":""} concluída{sorted.length!==1?"s":""}
        </span>
      </div>

      {/* Lista */}
      {sorted.length === 0 ? (
        <div style={{textAlign:"center",padding:"48px 0"}}>
          <div style={{fontSize:"40px",marginBottom:"12px"}}>✅</div>
          <p style={{color:G.white,fontFamily:HEADING,fontSize:"16px",fontWeight:"700",marginBottom:"4px",opacity:.9}}>Nenhuma tarefa concluída</p>
          <p style={{color:G.white,fontFamily:BODY,fontSize:"13px",opacity:.6}}>
            {dateFrom||dateTo||search||grpFilter ? "Tente outros filtros" : "Conclua tarefas para vê-las aqui"}
          </p>
        </div>
      ) : (
        <div style={{display:"flex",flexDirection:"column",gap:"8px"}}>
          {sorted.map((t,i) => (
        <div key={t.id} className="task-row fade-up" style={{
          animationDelay:`${i*.03}s`,
          background:G.white,
          border:`1px solid ${G.n200}`,
          borderRadius:"12px",
          padding:"6px 12px",
          boxShadow:"0 1px 4px rgba(0,0,0,.06)"
        }}>
          <div style={{display:"flex",alignItems:"flex-start",gap:"8px",marginBottom:"6px"}}>
            <p style={{color:G.n400,fontSize:"13px",fontWeight:"700",fontFamily:HEADING,letterSpacing:"-0.2px",lineHeight:1.25,textDecoration:"line-through",flex:1,margin:0}}>{t.title}</p>
            <span style={{fontSize:"10px",fontFamily:BODY,fontWeight:"600",color:G.g500,whiteSpace:"nowrap",flexShrink:0,background:G.g50,borderRadius:"6px",padding:"2px 6px"}}>✅ {fmtDoneAt(t.doneAt)}</span>
          </div>
          <div style={{display:"flex",flexWrap:"wrap",gap:"5px",alignItems:"center"}}>
            <div style={{width:"16px",height:"16px",borderRadius:"5px",background:G.g500,border:`2px solid ${G.g500}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginRight:"2px"}}>
              <svg width="8" height="7" viewBox="0 0 10 8" fill="none"><path d="M1 3.5L3.8 6.5L9 1" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </div>
            <span style={{background:priBg(t.priority),color:priColor(t.priority),borderRadius:"6px",padding:"2px 6px",fontSize:"10px",fontWeight:"600",fontFamily:BODY}}>● {t.priority}</span>
            <span style={{background:G.n100,color:G.n500,borderRadius:"6px",padding:"2px 6px",fontSize:"10px",fontFamily:BODY}}>{t.category}</span>
            {t.date && <span style={{color:G.n500,fontSize:"10px",fontFamily:BODY}}>📅 {t.date.split("-").reverse().join("/")}</span>}
            {t.groupTag && <span style={{color:G.n500,fontSize:"10px",fontFamily:BODY}}>🤝 {t.groupTag}</span>}
            {(t.withWhoTags||[]).length>0 && <span style={{color:G.n500,fontSize:"10px",fontFamily:BODY}}>🙋 {(t.withWhoTags||[]).join(", ")}</span>}
          </div>
        </div>
          ))}
        </div>
      )
    }
    </div>
  );
}

function Reports({ tasks, allTasks }) {
  const [repFilter, setRepFilter] = useState("Tudo");
  // eslint-disable-next-line no-unused-vars
  const filtered = (() => {
    if(repFilter==="Atrasadas") return tasks.filter(t=>!t.done&&t.date<tod());
    if(repFilter==="Hoje")      return tasks.filter(t=>t.date===tod());
    if(repFilter==="Amanhã")    return tasks.filter(t=>t.date===tmr());
    if(repFilter==="Semana")    return tasks.filter(t=>t.date>=tod()&&t.date<=wend());
    return tasks;
  })();
  const total = filtered.length;
  const done  = filtered.filter(t=>t.done).length;
  const pct   = total ? Math.round(done/total*100) : 0;
  const late  = filtered.filter(t=>!t.done&&t.date<tod()).length;
  const REP_FILTERS = ["Atrasadas","Hoje","Amanhã","Semana","Tudo"];
  const repCounts = {
    "Atrasadas": tasks.filter(t=>!t.done&&t.date<tod()).length,
    "Hoje":      tasks.filter(t=>t.date===tod()).length,
    "Amanhã":    tasks.filter(t=>t.date===tmr()).length,
    "Semana":    tasks.filter(t=>t.date>=tod()&&t.date<=wend()).length,
    "Tudo":      tasks.length,
  };

  return (
    <div style={{paddingBottom:"110px"}}>
      {/* Filter bar — mesmo estilo do Início */}
      <div style={{display:"flex",gap:"5px",marginBottom:"8px"}}>
        {REP_FILTERS.map(f=>(
          <button key={f} onClick={()=>setRepFilter(f)} style={{
            background: repFilter===f ? (f==="Atrasadas"?G.red:G.g500) : (f==="Atrasadas"&&repCounts[f]>0?"#FFF0F0":G.white),
            color: repFilter===f ? G.white : (f==="Atrasadas"&&repCounts[f]>0?G.red:G.n700),
            border:`1.5px solid ${repFilter===f?(f==="Atrasadas"?G.red:G.g500):(f==="Atrasadas"&&repCounts[f]>0?"#FECACA":G.n200)}`,
            borderRadius:"20px",padding:"7px 0",fontSize:"11px",fontWeight:"600",
            fontFamily:BODY,cursor:"pointer",whiteSpace:"nowrap",transition:"all .18s",
            flex:1,textAlign:"center",justifyContent:"center",display:"flex",alignItems:"center",gap:"6px",
            boxShadow: repFilter===f?(f==="Atrasadas"?"0 2px 12px rgba(239,68,68,.35)":`0 2px 10px ${G.glow}`):"none"
          }}>
            {f}
            <span style={{
              background:repFilter===f?"rgba(255,255,255,.28)":(f==="Atrasadas"&&repCounts[f]>0?"#FEE2E2":G.g100),
              color:repFilter===f?G.white:(f==="Atrasadas"&&repCounts[f]>0?G.red:G.g700),
              borderRadius:"10px",padding:"1px 7px",fontSize:"10px",fontWeight:"700"
            }}>{repCounts[f]}</span>
          </button>
        ))}
      </div>

      {/* KPI strip — compact horizontal row */}
      <div className="fade-up" style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:"8px",marginBottom:"8px"}}>
        {[
          {v:total,     l:"Total",    c:G.g700,  icon:"📋"},
          {v:done,      l:"Feitas",   c:G.g700,  icon:"✅"},
          {v:total-done,l:"Pend.",    c:G.amber, icon:"⏳"},
          {v:late,      l:"Atraso",   c:G.red,   icon:"⚠️"},  // eslint-disable-line
        ].map((s,i)=>(
          <div key={i} style={{background:G.white,border:`1px solid ${G.n200}`,borderRadius:"10px",padding:"8px 6px",textAlign:"center"}}>
            <div style={{fontSize:"14px",marginBottom:"3px"}}>{s.icon}</div>
            <p style={{color:s.c,fontFamily:HEADING,fontSize:"18px",fontWeight:"800",letterSpacing:"-0.5px",lineHeight:1}}>{s.v}</p>
            <p style={{color:G.n400||G.n500,fontFamily:BODY,fontSize:"10px",marginTop:"3px"}}>{s.l}</p>
          </div>
        ))}
      </div>

      {/* Completion ring — compact inline */}
      <div className="fade-up" style={{animationDelay:".12s",background:G.white,border:`1px solid ${G.n200}`,borderRadius:"14px",padding:"12px 14px",marginBottom:"8px",display:"flex",alignItems:"center",gap:"16px"}}>
        <div style={{position:"relative",flexShrink:0,width:"60px",height:"60px"}}>
          <svg width="60" height="60" viewBox="0 0 60 60">
            <circle cx="30" cy="30" r="24" fill="none" stroke={G.n200} strokeWidth="5"/>
            <circle cx="30" cy="30" r="24" fill="none" stroke={G.g500} strokeWidth="5"
              strokeDasharray={`${2*Math.PI*24*pct/100} ${2*Math.PI*24}`}
              strokeLinecap="round" transform="rotate(-90 30 30)"
              style={{transition:"stroke-dasharray 1.1s ease"}}/>
            <text x="30" y="34" textAnchor="middle" fill={G.n900} fontSize="12" fontWeight="800" fontFamily="Plus Jakarta Sans,sans-serif">{pct}%</text>
          </svg>
        </div>
        <div style={{flex:1}}>
          <p style={{color:G.n900,fontFamily:HEADING,fontSize:"14px",fontWeight:"700",marginBottom:"3px"}}>Taxa de conclusão</p>
          <p style={{color:G.n500,fontFamily:BODY,fontSize:"12px",marginBottom:"8px"}}>{done} de {total} tarefas</p>
          <div style={{height:"4px",background:G.n100,borderRadius:"2px"}}>
            <div style={{height:"100%",width:`${pct}%`,background:`linear-gradient(90deg,${G.g700},${G.g400})`,borderRadius:"2px",transition:"width 1.1s ease"}}/>
          </div>
        </div>
      </div>

      {/* Bar chart */}
      <BarChart tasks={tasks}/>

      {/* By category */}
      <div className="fade-up" style={{animationDelay:".44s",background:G.white,border:`1px solid ${G.n200}`,borderRadius:"14px",padding:"12px 14px",marginBottom:"8px"}}>
        <h3 style={{fontFamily:HEADING,fontSize:"13px",fontWeight:"700",color:G.n900,marginBottom:"8px"}}>Por Categoria</h3>
        {CATS.map(cat=>{
          const cnt=filtered.filter(t=>t.category===cat).length;
          const dn=filtered.filter(t=>t.category===cat&&t.done).length;
          return <div key={cat} style={{marginBottom:"12px"}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:"5px"}}>
              <span style={{color:G.n700,fontFamily:BODY,fontSize:"12px",fontWeight:"500"}}>{cat}</span>
              <span style={{color:G.n900,fontFamily:BODY,fontSize:"11px",fontWeight:"600"}}>{dn}/{cnt}</span>
            </div>
            <div style={{height:"5px",background:G.n100,borderRadius:"3px"}}>
              <div style={{height:"100%",width:`${cnt?(dn/cnt)*100:0}%`,background:`linear-gradient(90deg,${G.g700},${G.g400})`,borderRadius:"3px",transition:"width 1.1s ease"}}/>
            </div>
          </div>;
        })}
      </div>

      {/* By group */}
      <div className="fade-up" style={{animationDelay:".50s",background:G.white,border:`1px solid ${G.n200}`,borderRadius:"14px",padding:"12px 14px",marginBottom:"8px"}}>
        <h3 style={{fontFamily:HEADING,fontSize:"13px",fontWeight:"700",color:G.n900,marginBottom:"8px"}}>Por Grupo</h3>
        {(() => {
          const groups = [...new Set(tasks.map(t=>t.groupTag).filter(Boolean))];
          if(groups.length===0) return <p style={{color:G.n400,fontFamily:BODY,fontSize:"12px"}}>Nenhum grupo cadastrado nas tarefas</p>;
          return groups.map(g=>{
            const cnt=filtered.filter(t=>t.groupTag===g).length;
            const dn=filtered.filter(t=>t.groupTag===g&&t.done).length;
            return <div key={g} style={{marginBottom:"8px"}}>
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:"4px"}}>
                <span style={{color:G.n700,fontFamily:BODY,fontSize:"12px",fontWeight:"600"}}>🤝 {g}</span>
                <span style={{color:G.n900,fontFamily:BODY,fontSize:"11px",fontWeight:"600"}}>{dn}/{cnt}</span>
              </div>
              <div style={{height:"5px",background:G.n100,borderRadius:"3px"}}>
                <div style={{height:"100%",width:`${cnt?(dn/cnt)*100:0}%`,background:`linear-gradient(90deg,${G.g700},${G.g400})`,borderRadius:"3px",transition:"width 1.1s ease"}}/>
              </div>
            </div>;
          });
        })()}
      </div>

      {/* By priority */}
      <div className="fade-up" style={{animationDelay:".52s",background:G.white,border:`1px solid ${G.n200}`,borderRadius:"14px",padding:"12px 14px"}}>
        <h3 style={{fontFamily:HEADING,fontSize:"13px",fontWeight:"700",color:G.n900,marginBottom:"8px"}}>Por Prioridade</h3>
        {PRIS.map((p,i)=>{
          const clr=[G.red,G.amber,G.g500][i];
          const cnt=filtered.filter(t=>t.priority===p).length;
          const dn=filtered.filter(t=>t.priority===p&&t.done).length;
          return <div key={p} style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"11px"}}>
            <span style={{color:clr,fontFamily:BODY,fontSize:"11px",fontWeight:"700",width:"52px",flexShrink:0,whiteSpace:"nowrap"}}>● {p}</span>
            <div style={{flex:1,height:"5px",background:G.n100,borderRadius:"3px"}}>
              <div style={{height:"100%",width:`${cnt?(dn/cnt)*100:0}%`,background:clr,borderRadius:"3px",transition:"width 1.1s ease",opacity:.9}}/>
            </div>
            <span style={{color:G.n900,fontFamily:BODY,fontSize:"10px",fontWeight:"600",width:"26px",textAlign:"right",flexShrink:0}}>{dn}/{cnt}</span>
          </div>;
        })}
      </div>
    </div>
  );
}

// ─── PROFILE ─────────────────────────────────────────────────────────────────
function Profile({ user, setUser, tasks, onLogout }) {
  const [screen, setScreen]   = useState("main"); // main | editUser | notifications | privacy | support
  const [editData, setEditData] = useState({ name: user.name, phone: "", address: "", city: "" });
  const [notifEnabled, setNotifEnabled] = useState(true);
  const [notifBefore, setNotifBefore]   = useState("15min");

  const NOTIF_OPTIONS = [
    { val:"5min",   label:"5 minutos antes" },
    { val:"15min",  label:"15 minutos antes" },
    { val:"30min",  label:"30 minutos antes" },
    { val:"1h",     label:"1 hora antes" },
    { val:"2h",     label:"2 horas antes" },
    { val:"1d",     label:"1 dia antes" },
  ];

  const iStyle = {
    width:"100%", boxSizing:"border-box", background:G.n50,
    border:`1.5px solid ${G.n500}`, borderRadius:"10px",
    padding:"9px 12px", color:G.n900, fontSize:"13px",
    fontFamily:BODY, outline:"none", transition:"border-color .18s"
  };
  const lStyle = {
    display:"block", color:G.n900, fontSize:"11px", fontWeight:"700",
    letterSpacing:"0.7px", textTransform:"uppercase", marginBottom:"6px", fontFamily:BODY
  };

  // ── EDIT USER ──
  if (screen === "editUser") return (
    <div style={{paddingBottom:"80px"}}>
      <div style={{display:"flex",alignItems:"center",gap:"12px",marginBottom:"8px"}}>
        <button onClick={()=>setScreen("main")} style={{background:"none",border:"none",cursor:"pointer",fontSize:"20px",color:G.white}}>←</button>
        <h2 style={{fontFamily:HEADING,fontSize:"18px",fontWeight:"800",color:G.white,margin:0}}>Editar Perfil</h2>
      </div>
      <div style={{background:G.white,borderRadius:"16px",padding:"14px 16px",display:"flex",flexDirection:"column",gap:"10px",marginBottom:"10px"}}>
        {[
          {label:"Nome completo", key:"name",    placeholder:"Seu nome"},
          {label:"Telefone",      key:"phone",   placeholder:"(00) 00000-0000"},
          {label:"Endereço",      key:"address", placeholder:"Rua, número"},
          {label:"Cidade",        key:"city",    placeholder:"Cidade / Estado"},
        ].map(f=>(
          <div key={f.key}>
            <label style={lStyle}>{f.label}</label>
            <input value={editData[f.key]||""} onChange={e=>setEditData(d=>({...d,[f.key]:e.target.value}))}
              placeholder={f.placeholder} style={iStyle}
              onFocus={e=>e.target.style.borderColor=G.g500}
              onBlur={e=>e.target.style.borderColor=G.n500}
            />
          </div>
        ))}
        <div>
          <label style={lStyle}>E-mail (não editável)</label>
          <input value={user.email} disabled style={{...iStyle, background:G.n100, color:G.n500, cursor:"not-allowed"}}/>
        </div>
      </div>
      <button onClick={()=>{ setUser(u=>({...u, name:editData.name||u.name})); setScreen("main"); }} style={{
        width:"100%", background:G.g500, color:G.white, border:"none",
        borderRadius:"12px", padding:"11px", fontSize:"14px", fontWeight:"600",
        fontFamily:BODY, cursor:"pointer", boxShadow:`0 4px 16px ${G.glow}`
      }}>Salvar alterações</button>
    </div>
  );

  // ── NOTIFICAÇÕES ──
  if (screen === "notifications") return (
    <div style={{paddingBottom:"80px"}}>
      <div style={{display:"flex",alignItems:"center",gap:"12px",marginBottom:"8px"}}>
        <button onClick={()=>setScreen("main")} style={{background:"none",border:"none",cursor:"pointer",fontSize:"20px",color:G.white}}>←</button>
        <h2 style={{fontFamily:HEADING,fontSize:"18px",fontWeight:"800",color:G.white,margin:0}}>Notificações</h2>
      </div>
      <div style={{background:G.white,borderRadius:"14px",padding:"10px 14px",marginBottom:"6px"}}>
        {/* Toggle */}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",paddingBottom:"16px",borderBottom:`1px solid ${G.n100}`,marginBottom:"16px"}}>
          <div>
            <p style={{color:G.n900,fontFamily:BODY,fontSize:"15px",fontWeight:"600",marginBottom:"2px"}}>Ativar alertas</p>
            <p style={{color:G.n500,fontFamily:BODY,fontSize:"12px"}}>Receber lembretes das tarefas</p>
          </div>
          <div onClick={()=>setNotifEnabled(v=>!v)} style={{
            width:"48px",height:"26px",borderRadius:"13px",cursor:"pointer",
            background:notifEnabled?G.g500:G.n200,
            transition:"background .2s",position:"relative",flexShrink:0
          }}>
            <div style={{
              position:"absolute",top:"3px",
              left:notifEnabled?"23px":"3px",
              width:"20px",height:"20px",borderRadius:"50%",
              background:G.white,boxShadow:"0 1px 4px rgba(0,0,0,.2)",
              transition:"left .2s"
            }}/>
          </div>
        </div>
        {/* Antecedência */}
        {notifEnabled && (
          <div>
            <p style={{color:G.n900,fontFamily:BODY,fontSize:"14px",fontWeight:"600",marginBottom:"12px"}}>Lembrar com antecedência</p>
            <div style={{display:"flex",flexDirection:"column",gap:"8px"}}>
              {NOTIF_OPTIONS.map(opt=>(
                <div key={opt.val} onClick={()=>setNotifBefore(opt.val)} style={{
                  display:"flex",justifyContent:"space-between",alignItems:"center",
                  padding:"8px 12px",borderRadius:"8px",cursor:"pointer",
                  background:notifBefore===opt.val?G.g50:G.n50,
                  border:`1.5px solid ${notifBefore===opt.val?G.g500:G.n200}`,
                  transition:"all .15s"
                }}>
                  <span style={{color:G.n900,fontFamily:BODY,fontSize:"14px"}}>{opt.label}</span>
                  {notifBefore===opt.val && (
                    <div style={{width:"18px",height:"18px",borderRadius:"50%",background:G.g500,display:"flex",alignItems:"center",justifyContent:"center"}}>
                      <svg width="10" height="8" viewBox="0 0 10 8" fill="none"><path d="M1 3.5L3.8 6.5L9 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <button onClick={()=>setScreen("main")} style={{
        width:"100%", background:G.g500, color:G.white, border:"none",
        borderRadius:"12px", padding:"11px", fontSize:"14px", fontWeight:"600",
        fontFamily:BODY, cursor:"pointer", boxShadow:`0 4px 16px ${G.glow}`
      }}>Salvar preferências</button>
    </div>
  );

  // ── PRIVACIDADE ──
  if (screen === "privacy") return (
    <div style={{paddingBottom:"80px"}}>
      <div style={{display:"flex",alignItems:"center",gap:"12px",marginBottom:"8px"}}>
        <button onClick={()=>setScreen("main")} style={{background:"none",border:"none",cursor:"pointer",fontSize:"20px",color:G.white}}>←</button>
        <h2 style={{fontFamily:HEADING,fontSize:"18px",fontWeight:"800",color:G.white,margin:0}}>Privacidade</h2>
      </div>
      <div style={{background:G.white,borderRadius:"14px",padding:"10px 14px",marginBottom:"6px"}}>
        <p style={{color:G.n900,fontFamily:HEADING,fontSize:"15px",fontWeight:"700",marginBottom:"12px"}}>Seus dados</p>
        <p style={{color:G.n500,fontFamily:BODY,fontSize:"13px",lineHeight:1.6,marginBottom:"16px"}}>
          O Dia Resolvido armazena suas tarefas e preferências com segurança. Nenhum dado pessoal é compartilhado com terceiros.
        </p>
        {[
          {icon:"🔐", t:"Dados criptografados", s:"Suas informações são protegidas localmente"},
          {icon:"🚫", t:"Sem rastreamento",      s:"Não coletamos dados de uso ou comportamento"},
          {icon:"📵", t:"Sem anúncios",          s:"O app não exibe publicidade de nenhum tipo"},
        ].map(item=>(
          <div key={item.t} style={{display:"flex",gap:"12px",alignItems:"flex-start",padding:"12px 0",borderBottom:`1px solid ${G.n100}`}}>
            <span style={{fontSize:"20px",flexShrink:0}}>{item.icon}</span>
            <div>
              <p style={{color:G.n900,fontFamily:BODY,fontSize:"13px",fontWeight:"600"}}>{item.t}</p>
              <p style={{color:G.n500,fontFamily:BODY,fontSize:"12px",marginTop:"2px"}}>{item.s}</p>
            </div>
          </div>
        ))}
      </div>
      <button onClick={onLogout} style={{
        width:"100%", background:G.white, color:G.red,
        border:`1.5px solid #FEE2E2`, borderRadius:"12px", padding:"13px",
        fontSize:"14px", fontWeight:"600", fontFamily:BODY, cursor:"pointer"
      }}>Excluir minha conta</button>
    </div>
  );

  // ── SUPORTE ──
  if (screen === "support") return (
    <div style={{paddingBottom:"80px"}}>
      <div style={{display:"flex",alignItems:"center",gap:"12px",marginBottom:"8px"}}>
        <button onClick={()=>setScreen("main")} style={{background:"none",border:"none",cursor:"pointer",fontSize:"20px",color:G.white}}>←</button>
        <h2 style={{fontFamily:HEADING,fontSize:"18px",fontWeight:"800",color:G.white,margin:0}}>Suporte</h2>
      </div>
      <div style={{background:G.white,borderRadius:"14px",padding:"10px 14px",marginBottom:"6px"}}>
        <p style={{color:G.n900,fontFamily:HEADING,fontSize:"15px",fontWeight:"700",marginBottom:"4px"}}>Precisa de ajuda?</p>
        <p style={{color:G.n500,fontFamily:BODY,fontSize:"13px",marginBottom:"20px"}}>Entre em contato com nossa equipe.</p>
        {[
          {icon:"📧", t:"E-mail", s:"suporte@vvConsultoria.com.br", color:G.g500},
          {icon:"💬", t:"WhatsApp", s:"(00) 00000-0000", color:G.g500},
          {icon:"🌐", t:"Site", s:"www.vvconsultoria.com.br", color:G.g500},
        ].map(item=>(
          <div key={item.t} style={{display:"flex",gap:"14px",alignItems:"center",padding:"14px 0",borderBottom:`1px solid ${G.n100}`}}>
            <div style={{width:"40px",height:"40px",borderRadius:"12px",background:G.g50,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"18px",flexShrink:0}}>{item.icon}</div>
            <div>
              <p style={{color:G.n500,fontFamily:BODY,fontSize:"11px",fontWeight:"600",textTransform:"uppercase",letterSpacing:"0.5px"}}>{item.t}</p>
              <p style={{color:item.color,fontFamily:BODY,fontSize:"14px",fontWeight:"600",marginTop:"1px"}}>{item.s}</p>
            </div>
          </div>
        ))}
      </div>
      <div style={{background:G.white,borderRadius:"16px",padding:"14px 16px"}}>
        <p style={{color:G.n900,fontFamily:HEADING,fontSize:"14px",fontWeight:"700",marginBottom:"14px"}}>Perguntas frequentes</p>
        {[
          {q:"Como criar uma tarefa recorrente?", a:"Ao criar a tarefa, selecione a recorrência desejada e defina a data final do período."},
          {q:"Como exportar minhas tarefas?", a:"Em breve disponível. Nossa equipe está desenvolvendo essa funcionalidade."},
          {q:"Posso usar em vários dispositivos?", a:"Atualmente o app funciona localmente. Sincronização em nuvem está no roadmap."},
        ].map((item,i,arr)=>(
          <details key={item.q} style={{borderBottom:i<arr.length-1?`1px solid ${G.n100}`:"none",paddingBottom:"12px",marginBottom:"12px"}}>
            <summary style={{color:G.n900,fontFamily:BODY,fontSize:"13px",fontWeight:"600",cursor:"pointer",listStyle:"none",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              {item.q} <span style={{color:G.g500,fontSize:"16px"}}>+</span>
            </summary>
            <p style={{color:G.n500,fontFamily:BODY,fontSize:"12px",lineHeight:1.6,marginTop:"8px"}}>{item.a}</p>
          </details>
        ))}
      </div>
    </div>
  );

  // ── MAIN ──
  return (
    <div style={{paddingBottom:"80px"}}>
      {/* user hero */}
      <div className="fade-up" style={{background:`linear-gradient(135deg,${G.g900},${G.g700})`,borderRadius:"14px",padding:"12px",marginBottom:"8px",position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",top:"-40px",right:"-40px",width:"160px",height:"160px",borderRadius:"50%",background:"rgba(255,255,255,.05)",pointerEvents:"none"}}/>
        <div style={{display:"flex",alignItems:"center",gap:"12px",marginBottom:"12px"}}>
          <div style={{
            width:"44px",height:"44px",borderRadius:"12px",
            background:`linear-gradient(135deg,${G.g400},${G.g500})`,
            display:"flex",alignItems:"center",justifyContent:"center",
            fontSize:"22px",fontWeight:"800",color:G.white,fontFamily:HEADING,
            boxShadow:"0 4px 16px rgba(0,0,0,.2)",flexShrink:0
          }}>{user.name[0].toUpperCase()}</div>
          <div style={{flex:1}}>
            <h2 style={{fontFamily:HEADING,fontSize:"16px",fontWeight:"800",color:G.white,marginBottom:"2px",letterSpacing:"-0.3px"}}>{user.name}</h2>
            <p style={{color:"rgba(255,255,255,.55)",fontFamily:BODY,fontSize:"13px"}}>{user.email}</p>
          </div>
          <button onClick={()=>setScreen("editUser")} style={{
            background:"rgba(255,255,255,.15)",border:"1px solid rgba(255,255,255,.25)",
            borderRadius:"10px",padding:"8px 14px",color:G.white,fontFamily:BODY,
            fontSize:"12px",fontWeight:"600",cursor:"pointer",flexShrink:0,
            display:"flex",alignItems:"center",gap:"6px"
          }}>✏️ Editar</button>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:"1px",background:"rgba(255,255,255,.1)",borderRadius:"12px",overflow:"hidden"}}>
          {[["Tarefas",tasks.length],["Feitas",tasks.filter(t=>t.done).length],["Streak","4🔥"]].map(([l,v])=>(
            <div key={l} style={{background:G.g900,padding:"10px 8px",textAlign:"center"}}>
              <p style={{color:G.white,fontFamily:HEADING,fontSize:"20px",fontWeight:"800",letterSpacing:"-0.5px"}}>{v}</p>
              <p style={{color:"rgba(255,255,255,.45)",fontFamily:BODY,fontSize:"11px",marginTop:"2px"}}>{l}</p>
            </div>
          ))}
        </div>
      </div>

      {/* menu */}
      <div style={{background:G.white,border:`1px solid ${G.n200}`,borderRadius:"18px",overflow:"hidden",marginBottom:"12px"}}>
        {[
          {icon:"🔔", label:"Notificações", sub: notifEnabled?"Ativado — "+NOTIF_OPTIONS.find(o=>o.val===notifBefore)?.label:"Desativado", action:()=>setScreen("notifications")},
          {icon:"🔒", label:"Privacidade",  sub:"Dados e segurança",  action:()=>setScreen("privacy")},
          {icon:"❓", label:"Suporte",      sub:"Ajuda e contato",    action:()=>setScreen("support")},
        ].map((item,i,arr)=>(
          <div key={item.label} onClick={item.action} className="menu-row" style={{
            padding:"12px 16px",
            borderBottom: i<arr.length-1 ? `1px solid ${G.n100}` : "none",
            display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",
            background:G.white
          }}>
            <div style={{display:"flex",gap:"14px",alignItems:"center"}}>
              <div style={{width:"30px",height:"30px",borderRadius:"8px",background:G.n50,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"17px"}}>{item.icon}</div>
              <div>
                <p style={{color:G.n900,fontFamily:BODY,fontSize:"13px",fontWeight:"500"}}>{item.label}</p>
                <p style={{color:G.n300,fontFamily:BODY,fontSize:"11px",marginTop:"1px"}}>{item.sub}</p>
              </div>
            </div>
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none"><path d="M1 1L6 6L1 11" stroke={G.n300} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </div>
        ))}
      </div>

      <button onClick={onLogout} style={{
        width:"100%", background:G.white, color:G.red,
        border:`1.5px solid #FEE2E2`, borderRadius:"12px", padding:"10px",
        fontSize:"13px", fontWeight:"600", fontFamily:BODY, cursor:"pointer", transition:"all .18s"
      }}
        onMouseEnter={e=>{e.currentTarget.style.background="#FEF2F2";}}
        onMouseLeave={e=>{e.currentTarget.style.background=G.white;}}
      >Sair da conta</button>
    </div>
  );
}

// ─── APP ──────────────────────────────────────────────────────────────────────
export default function App() {
  const [user,     setUser]      = useState(null);
  const [tasks,    setTasks]     = useState([]);
  const [loading,  setLoading]   = useState(true);
  const [tab,      setTab]       = useState("home");
  const switchTab = (id) => { setTab(id); window.scrollTo({top:0,behavior:"smooth"}); };
  const [filter,   setFilter]    = useState("Hoje");
  const [modal,    setModal]     = useState(false);
  const [editTask, setEditTask]  = useState(null);
  const [search,   setSearch]    = useState("");
  const [sfocus,   setSfocus]    = useState(false);
  const [groupFilter, setGroupFilter] = useState("");
  const [groupDDOpen, setGroupDDOpen] = useState(false);
  const [groupDDPos,  setGroupDDPos]  = useState({top:0, left:0});
  const [dragId,   setDragId]    = useState(null);
  const dragOver                     = useRef(null);

  const moveTask = (fromId, toId) => {
    if (!fromId || fromId === toId) return;
    setTasks(ts => {
      // ordena a lista atual (respeitando manualOrder existente) antes de mover
      const sorted = sortTasks(ts);
      const from = sorted.findIndex(t=>t.id===fromId);
      const to   = sorted.findIndex(t=>t.id===toId);
      if(from<0||to<0) return ts;
      const arr = [...sorted];
      const [item] = arr.splice(from,1);
      arr.splice(to,0,item);
      // atribui numeral manualOrder sequencial — esse numeral passa a mandar na ordenação
      const reordered = arr.map((t,i)=>({...t, manualOrder:i}));
      // persiste cada tarefa atualizada no storage
      reordered.forEach(t => supa.updateTask(t.id, { manualOrder: t.manualOrder }));
      // mescla de volta com tarefas que não estavam nessa lista filtrada (outros dias/filtros)
      const reorderedIds = new Set(reordered.map(t=>t.id));
      const untouched = ts.filter(t => !reorderedIds.has(t.id));
      return [...untouched, ...reordered];
    });
  };

  // Desktop drag (cards inteiros, mouse)
  const handleDragStart = (id)       => setDragId(id);
  const handleDragOver  = (e, overId)=> { e.preventDefault(); dragOver.current=overId; };
  const handleDragEnd   = ()         => { moveTask(dragId, dragOver.current); setDragId(null); dragOver.current=null; };

  // Mobile touch — só pela alça dedicada (⠿), sem conflitar com botões/checkbox
  const touchStart = useRef(null);
  const touchEl    = useRef(null);
  const handleHandleTouchStart = (e, id) => {
    e.stopPropagation();
    touchStart.current = id;
    setDragId(id);
    const card = e.currentTarget.closest("[data-taskid]");
    touchEl.current = card;
    if (card) { card.style.opacity = "0.5"; card.style.transform = "scale(1.02)"; }
  };
  const handleHandleTouchMove = (e) => {
    if (!touchStart.current) return;
    e.preventDefault();
    const touch = e.touches[0];
    const el = document.elementFromPoint(touch.clientX, touch.clientY);
    const card = el?.closest("[data-taskid]");
    if (card) dragOver.current = card.dataset.taskid;
  };
  const handleHandleTouchEnd = () => {
    if(touchEl.current){ touchEl.current.style.opacity="1"; touchEl.current.style.transform=""; }
    moveTask(touchStart.current, dragOver.current);
    touchStart.current=null; dragOver.current=null; touchEl.current=null;
    setDragId(null);
  };

  // ── Restaurar sessão ──
  useEffect(() => {
    try {
      const session = LS.get("dr_session");
      if (session?.id) setUser(session);
    } catch(e) {}
    setLoading(false);
  }, []);

  // ── Load tasks when user logs in ──
  useEffect(() => {
    if (!user?.id) return;
    loadTasks();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  const loadTasks = () => {
    const data = supa.getTasks(user.id);
    const sorted = [...data].sort((a,b)=>{
      const da=(a.date||"")+(a.time||"00:00");
      const db2=(b.date||"")+(b.time||"00:00");
      return da<db2?-1:da>db2?1:0;
    });
    setTasks(sorted);
  };

  // ── DB ↔ App converters ──
  // ── Helpers localStorage ──────────────────────────────────────────────────

  const toggleTask = (id) => {
    const task = tasks.find(t => t.id === id);
    if (!task) return;
    const newDone = !task.done;
    const doneAt  = newDone ? new Date().toISOString() : null;
    setTasks(ts => ts.map(t => t.id===id ? {...t, done:newDone, doneAt} : t));
    supa.updateTask(id, { done: newDone, doneAt });
  };

  const [confirmDelete, setConfirmDelete] = useState(null);
  const deleteTask = id => setConfirmDelete(id);
  const confirmDeleteTask = () => {
    supa.deleteTask(confirmDelete);
    setTasks(ts => ts.filter(t => t.id !== confirmDelete));
    setConfirmDelete(null);
  };

  const saveTask = (input) => {
    const arr = Array.isArray(input) ? input : [input];
    const groupId = arr[0].groupId;
    const existingId = arr[0].id;
    const isEdit = !groupId && existingId && tasks.find(t => t.id === existingId);

    if (isEdit) {
      // EDIÇÃO: atualiza no lugar, mantém o mesmo id
      const updated = { ...arr[0], user_id: user.id };
      supa.updateTask(existingId, updated);
      setTasks(ts => ts.map(t => t.id === existingId ? updated : t));
    } else {
      // CRIAÇÃO ou GRUPO RECORRENTE
      if (groupId) {
        supa.deleteGroup(groupId);
        setTasks(ts => ts.filter(t => t.groupId !== groupId));
      }
      const newTasks = arr.map(t => ({
        ...t,
        id: "r_" + Date.now() + "_" + Math.random().toString(36).slice(2),
        user_id: user.id,
        done: t.done || false,
      }));
      supa.saveTasks(newTasks);
      setTasks(ts => [...ts, ...newTasks]);
    }
  };

  const FILTERS = ["Atrasadas","Hoje","Amanhã","Semana"];
  const counts = {
    "Atrasadas":tasks.filter(t=>!t.done&&t.date<tod()).length,
    "Hoje":  tasks.filter(t=>t.date===tod()).length,
    "Amanhã":tasks.filter(t=>t.date===tmr()).length,
    "Semana":tasks.filter(t=>t.date>=tod()&&t.date<=wend()).length,
    "Tudo":  tasks.length,
  };
  const filtered = tasks.filter(t=>{
    const ms = t.title.toLowerCase().includes(search.toLowerCase());
    const gf = !groupFilter || t.groupTag===groupFilter;
    if(filter==="Atrasadas") return !t.done&&t.date<tod()&&ms&&gf;
    if(filter==="Hoje")   return t.date===tod()&&ms&&gf;
    if(filter==="Amanhã") return t.date===tmr()&&ms&&gf;
    if(filter==="Semana") return t.date>=tod()&&t.date<=wend()&&ms&&gf;
    return ms&&gf;
  });

  const doneT  = tasks.filter(t=>t.date===tod()&&t.done).length;
  const pendT  = tasks.filter(t=>t.date===tod()&&!t.done).length;
  const totT   = doneT+pendT;
  const pctT   = totT ? Math.round(doneT/totT*100) : 0;



  const dateLabel = new Date().toLocaleDateString("pt-BR",{weekday:"long",day:"2-digit",month:"long"});

  if (loading) return (
    <div style={{minHeight:"100vh",background:"linear-gradient(160deg,#166534 0%,#16A34A 60%,#14532D 100%)",display:"flex",alignItems:"center",justifyContent:"center"}}>
      <GStyle/>
      <div style={{textAlign:"center"}}>
        <div style={{width:"44px",height:"44px",borderRadius:"12px",background:"rgba(255,255,255,.15)",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 14px"}}>
        <svg width="32" height="32" viewBox="0 0 26 26" fill="none">
          <rect x="2" y="2" width="22" height="22" rx="6" fill="rgba(255,255,255,.9)"/>
          <path d="M7 13L11 17L19 9" stroke="#166534" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
        <p style={{color:"rgba(255,255,255,.8)",fontFamily:"'Inter',sans-serif",fontSize:"14px"}}>Carregando...</p>
      </div>
    </div>
  );
  if (!user) return <LoginScreen onLogin={(u)=>{ setUser(u); LS.set("dr_session", u); }}/>;

  const NAV = [
    {id:"home",     icon:<HomeIcon/>,  label:"Início"},
    {id:"reports",  icon:<ChartIcon/>, label:"Relatórios"},
    {id:"done",     icon:<DoneIcon/>,  label:"Realizados"},
    {id:"profile",  icon:<UserIcon/>,  label:"Perfil"},
  ];

  return (
    <div style={{minHeight:"100vh",background:"transparent",maxWidth:"480px",margin:"0 auto",fontFamily:BODY,position:"relative"}}>
      <GStyle/><AppBgPattern/>
      <div style={{position:"relative",zIndex:1}}>

        {/* ── HEADER ── */}
        <div style={{position:"relative",zIndex:1}}>

          {/* ── TÍTULO PADRÃO (card branco) ── */}
          <div style={{
            background:G.white,
            margin:"16px 16px 0",
            borderRadius:"16px",
            padding:"14px 18px",
            boxShadow:"0 4px 20px rgba(0,0,0,.25)",
            display:"flex",justifyContent:"space-between",alignItems:"center",
          }}>
            <div style={{flex:1,minWidth:0}}>
              <p style={{color:G.g500,fontSize:"11px",fontFamily:BODY,fontWeight:"600",
                letterSpacing:"0.5px",textTransform:"capitalize",marginBottom:"3px"}}>
                {dateLabel}
              </p>
              <h1 style={{fontFamily:HEADING,fontSize:"20px",fontWeight:"800",
                color:G.g900,letterSpacing:"-0.5px",lineHeight:1.15,margin:0}}>
                {tab==="home" && <>DIA <span style={{color:G.g500}}>RESOLVIDO</span> <span style={{color:G.n500,fontWeight:"500",fontSize:"14px"}}>— {totT} tarefa{totT!==1?"s":""} hoje</span></>}
                {tab==="done"    && <>DIA <span style={{color:G.g500}}>RESOLVIDO</span> <span style={{color:G.n500,fontWeight:"500",fontSize:"14px"}}>— Realizados</span></> }
            {tab==="reports" && <>DIA <span style={{color:G.g500}}>RESOLVIDO</span> <span style={{color:G.n500,fontWeight:"500",fontSize:"14px"}}>— Relatórios</span></>}
                {tab==="profile" && <>DIA <span style={{color:G.g500}}>RESOLVIDO</span> <span style={{color:G.n500,fontWeight:"500",fontSize:"14px"}}>— Perfil</span></>}
              </h1>
            </div>
            {tab==="home" && (
              <button onClick={()=>{setEditTask(null);setModal(true);}} style={{
                width:"40px",height:"40px",borderRadius:"11px",border:"none",flexShrink:0,marginLeft:"12px",
                background:G.g500,color:G.white,fontSize:"22px",cursor:"pointer",
                display:"flex",alignItems:"center",justifyContent:"center",
                boxShadow:`0 4px 14px ${G.glow}`,transition:"background .18s"
              }}
                onMouseEnter={e=>e.currentTarget.style.background=G.g700}
                onMouseLeave={e=>e.currentTarget.style.background=G.g500}
              >+</button>
            )}
          </div>

          {/* ── CONTEÚDO EXTRA DO HOME ── */}
          {tab==="home" && (
            <div style={{padding:"10px 16px 0"}}>

              {/* 1. Progresso de hoje */}
              {totT>0 && (
                <div style={{background:G.white,border:`1px solid ${G.g200}`,borderRadius:"10px",padding:"8px 12px",marginBottom:"10px"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"5px"}}>
                    <span style={{color:G.n700,fontSize:"11px",fontFamily:BODY,fontWeight:"500"}}>Progresso de hoje</span>
                    <span style={{color:G.g500,fontSize:"11px",fontWeight:"700",fontFamily:HEADING}}>{pctT}% · {doneT}/{totT}</span>
                  </div>
                  <div style={{height:"4px",background:G.n100,borderRadius:"2px"}}>
                    <div style={{height:"100%",width:`${pctT}%`,background:`linear-gradient(90deg,${G.g700},${G.g400})`,borderRadius:"2px",transition:"width .7s ease"}}/>
                  </div>
                </div>
              )}

              {/* 2. Filtros de período */}
              <div style={{display:"flex",gap:"5px",marginBottom:"6px"}}>
                {FILTERS.map(f=>(
                  <button key={f} onClick={()=>setFilter(f)} style={{
                    background: filter===f ? (f==="Atrasadas" ? G.red : G.g500) : (f==="Atrasadas"&&counts[f]>0 ? "#FFF0F0" : G.white),
                    color: filter===f ? G.white : (f==="Atrasadas"&&counts[f]>0 ? G.red : G.n700),
                    border:`1.5px solid ${filter===f ? (f==="Atrasadas" ? G.red : G.g500) : (f==="Atrasadas"&&counts[f]>0 ? "#FECACA" : G.n200)}`,
                    borderRadius:"20px",padding:"7px 0",fontSize:"11px",fontWeight:"600",
                    fontFamily:BODY,cursor:"pointer",whiteSpace:"nowrap",transition:"all .18s",flex:1,textAlign:"center",
                    justifyContent:"center",display:"flex",alignItems:"center",gap:"6px",
                    boxShadow: filter===f ? (f==="Atrasadas" ? "0 2px 12px rgba(239,68,68,.35)" : `0 2px 10px ${G.glow}`) : "none"
                  }}>
                    {f}
                    <span style={{
                      background: filter===f ? "rgba(255,255,255,.28)" : (f==="Atrasadas"&&counts[f]>0?"#FEE2E2":G.g100),
                      color: filter===f ? G.white : (f==="Atrasadas"&&counts[f]>0?G.red:G.g700),
                      borderRadius:"10px",padding:"1px 7px",fontSize:"10px",fontWeight:"700"
                    }}>{counts[f]}</span>
                  </button>
                ))}
              </div>

              {/* 3. Grupos + Buscar — mesma linha */}
              <div style={{display:"flex",gap:"8px",marginBottom:"10px",alignItems:"center",position:"relative",zIndex:200}}>

                {/* Dropdown Grupos */}
                <div style={{position:"relative",width:"35%",zIndex:201}}>
                  <button onClick={e=>{const r=e.currentTarget.getBoundingClientRect();setGroupDDPos({top:r.bottom+4,left:r.left});setGroupDDOpen(v=>!v);}} style={{
                    width:"100%",height:"36px",padding:"0 10px",borderRadius:"10px",cursor:"pointer",
                    background:groupFilter?G.g500:G.white,
                    color:groupFilter?G.white:G.n700,
                    border:`1.5px solid ${groupFilter?G.g500:G.g200}`,
                    fontSize:"12px",fontWeight:"600",fontFamily:BODY,
                    display:"flex",alignItems:"center",justifyContent:"space-between",whiteSpace:"nowrap",
                    boxShadow:groupFilter?`0 2px 8px ${G.glow}`:"none"
                  }}>
                    <span>👨‍👩‍👧‍👦 {groupFilter||"Grupos"}</span>
                    <span style={{fontSize:"9px",marginLeft:"4px"}}>{groupDDOpen?"▲":"▼"}</span>
                  </button>

                </div>

                {/* Buscar */}
                <div style={{position:"relative",flex:1,minWidth:0}}>
                  <span style={{position:"absolute",left:"10px",top:"50%",transform:"translateY(-50%)",color:sfocus?G.g500:G.n400,fontSize:"13px"}}>⌕</span>
                  <input value={search} onChange={e=>setSearch(e.target.value)}
                    onFocus={()=>setSfocus(true)} onBlur={()=>setSfocus(false)}
                    placeholder="Buscar tarefa…"
                    style={{width:"100%",boxSizing:"border-box",background:G.white,border:`1.5px solid ${sfocus?G.g500:G.g200}`,borderRadius:"10px",padding:"8px 10px 8px 28px",color:G.n900,fontSize:"13px",fontFamily:BODY,outline:"none",transition:"border-color .18s"}}
                  />
                </div>

              </div>

            </div>
          )}
        </div>

        {/* ── CONTENT ── */}
        <div key={tab} style={{padding:`${tab==="home"?"0":"10px"} 16px 110px`,background:"transparent",position:"relative",zIndex:1}}>

          {tab==="home" && (
            filtered.length===0
            ? <div style={{textAlign:"center",padding:"72px 0",animation:"fadeUp .4s ease both"}}>
                <div style={{width:"44px",height:"44px",borderRadius:"12px",background:G.g50,display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 14px",fontSize:"24px"}}>📋</div>
                <p style={{color:G.n500,fontFamily:BODY,fontSize:"14px",marginBottom:"18px"}}>Nenhuma tarefa encontrada</p>

              </div>
            : <div style={{display:"flex",flexDirection:"column",gap:"8px"}}>
                {(filter==="Semana"||filter==="Tudo") ? (() => {
                  const grp = {};
                  filtered.forEach(t=>{if(!grp[t.date])grp[t.date]=[];grp[t.date].push(t);});
                  return Object.keys(grp).sort().map(date=>(
                    <div key={date}>
                      <div style={{display:"flex",alignItems:"center",gap:"10px",margin:"16px 0 9px"}}>
                        <span style={{color:G.g500,fontSize:"11px",fontWeight:"700",fontFamily:BODY,letterSpacing:"1px",textTransform:"uppercase"}}>{fmtDate(date)}</span>
                        <div style={{flex:1,height:"1px",background:G.n200}}/>
                        <span style={{color:G.n300,fontSize:"11px",fontFamily:BODY}}>{grp[date].length} item{grp[date].length>1?"s":""}</span>
                      </div>
                      {sortTasks(grp[date]).map((t,i)=>(
                        <div key={t.id} data-taskid={t.id}
                          draggable
                          onDragStart={()=>handleDragStart(t.id)}
                          onDragOver={e=>handleDragOver(e,t.id)}
                          onDragEnd={handleDragEnd}
                          style={{marginBottom:"-4px",opacity:dragId===t.id ? 0.4 : 1,transition:"opacity .2s"}}
                        >
                        <TaskCard task={t} onToggle={toggleTask} onEdit={t=>{setEditTask(t);setModal(true);}} onDelete={deleteTask} i={i}
                          onHandleTouchStart={e=>handleHandleTouchStart(e,t.id)}
                          onHandleTouchMove={handleHandleTouchMove}
                          onHandleTouchEnd={handleHandleTouchEnd}
                        />
                        </div>
                      ))}
                    </div>
                  ));
                })()
                : sortTasks(filtered).map((t,i)=>(
                  <div key={t.id} data-taskid={t.id} draggable
                    onDragStart={()=>handleDragStart(t.id)} onDragOver={e=>handleDragOver(e,t.id)} onDragEnd={handleDragEnd}
                    style={{marginBottom:"-4px",opacity:dragId===t.id ? 0.4 : 1}}>
                    <TaskCard task={t} onToggle={toggleTask} onEdit={t=>{setEditTask(t);setModal(true);}} onDelete={deleteTask} i={i}
                      onHandleTouchStart={e=>handleHandleTouchStart(e,t.id)}
                      onHandleTouchMove={handleHandleTouchMove}
                      onHandleTouchEnd={handleHandleTouchEnd}
                    />
                  </div>
                ))
                }
              </div>
          )}

          {tab==="done"    && <Realized tasks={tasks}/>}
          {tab==="reports" && <Reports tasks={tasks} allTasks={tasks}/>}
          {tab==="profile" && <Profile user={user} setUser={setUser} tasks={tasks} onLogout={async()=>{ await supa.auth.signOut(); setUser(null); setTasks([]); LS.del("dr_session"); }}/>}
        </div>

        {/* ── BOTTOM NAV ── */}
        <div style={{
          position:"fixed",bottom:0,left:"50%",transform:"translateX(-50%)",
          width:"100%",maxWidth:"480px",zIndex:50,
          background:"rgba(240,253,244,.97)",backdropFilter:"blur(20px)",
          borderTop:`1px solid ${G.n200}`,padding:"4px 24px 12px",
          display:"flex",justifyContent:"space-around",alignItems:"center"
        }}>
          {NAV.map(n=>(
            <button key={n.id} onClick={()=>switchTab(n.id)} style={{
              background:"none",border:"none",cursor:"pointer",
              display:"flex",flexDirection:"column",alignItems:"center",gap:"1px",padding:"1px 14px"
            }}>
              <div style={{
                width:"36px",height:"36px",borderRadius:"10px",
                background: tab===n.id ? G.g50 : "rgba(0,0,0,.04)",
                display:"flex",alignItems:"center",justifyContent:"center",transition:"background .18s"
              }}>
                <div style={{color: tab===n.id ? G.g500 : G.n500, transition:"color .18s", transform:"scale(1.18)"}}>
                  {n.icon}
                </div>
              </div>
              <span style={{color:tab===n.id?G.g500:G.n500,fontSize:"11px",fontWeight:"600",fontFamily:BODY,letterSpacing:".2px",transition:"color .18s"}}>
                {n.label}
              </span>

            </button>
          ))}


        </div>
      </div>

      {modal && <TaskModal task={editTask} onSave={t=>{saveTask(t);setEditTask(null);}} onClose={()=>{setModal(false);setEditTask(null);}}/>}
      {confirmDelete && (
        <div style={{position:"fixed",inset:0,zIndex:300,background:"rgba(15,23,42,.45)",backdropFilter:"blur(6px)",display:"flex",alignItems:"center",justifyContent:"center",padding:"24px"}} onClick={()=>setConfirmDelete(null)}>
          <div onClick={e=>e.stopPropagation()} style={{background:G.white,borderRadius:"18px",padding:"28px 24px",width:"100%",maxWidth:"320px",boxShadow:"0 20px 60px rgba(0,0,0,.18)",animation:"fadeUp .25s ease both"}}>
            <div style={{width:"48px",height:"48px",borderRadius:"14px",background:"#FEF2F2",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 16px",fontSize:"22px"}}>🗑️</div>
            <h3 style={{fontFamily:HEADING,fontSize:"18px",fontWeight:"800",color:G.n900,textAlign:"center",marginBottom:"8px",letterSpacing:"-0.3px"}}>Remover tarefa?</h3>
            <p style={{color:G.n500,fontFamily:BODY,fontSize:"13px",textAlign:"center",lineHeight:1.5,marginBottom:"22px"}}>Essa ação não pode ser desfeita. Tem certeza que deseja deletar esta tarefa?</p>
            <div style={{display:"flex",gap:"10px"}}>
              <button onClick={()=>setConfirmDelete(null)} style={{flex:1,background:G.n100,color:G.n700,border:"none",borderRadius:"10px",padding:"12px",fontSize:"14px",fontWeight:"600",fontFamily:BODY,cursor:"pointer"}}>Cancelar</button>
              <button onClick={confirmDeleteTask} style={{flex:1,background:G.red,color:G.white,border:"none",borderRadius:"10px",padding:"12px",fontSize:"14px",fontWeight:"600",fontFamily:BODY,cursor:"pointer",boxShadow:"0 4px 12px rgba(239,68,68,.3)"}}>Sim, deletar</button>
            </div>
          </div>
        </div>
      )}
      {/* ── GROUP DROPDOWN — fora do zIndex:1, sobrepõe tudo ── */}
      {groupDDOpen && (
        <>
          <div onClick={()=>setGroupDDOpen(false)} style={{position:"fixed",inset:0,zIndex:9998}}/>
          <div style={{
            position:"fixed",
            top:groupDDPos.top,
            left:groupDDPos.left,
            zIndex:9999,
            background:G.white,
            border:`1.5px solid ${G.g200}`,
            borderRadius:"12px",
            padding:"6px",
            minWidth:"180px",
            boxShadow:"0 8px 32px rgba(0,0,0,.25)"
          }}>
            <div onClick={()=>{setGroupFilter("");setGroupDDOpen(false);}} style={{padding:"8px 12px",borderRadius:"8px",cursor:"pointer",background:!groupFilter?G.g50:"transparent",color:!groupFilter?G.g700:G.n700,fontSize:"12px",fontFamily:BODY,fontWeight:!groupFilter?"600":"400"}}>
              🔍 Todos os grupos
            </div>
            {(LS.get("dr_groups")||[]).length===0
              ? <p style={{color:G.n400,fontSize:"11px",fontFamily:BODY,padding:"6px 12px"}}>Nenhum grupo cadastrado</p>
              : (LS.get("dr_groups")||[]).map((g,gi)=>(
                <div key={gi} onClick={()=>{setGroupFilter(g.name);setGroupDDOpen(false);}} style={{
                  padding:"8px 12px",borderRadius:"8px",cursor:"pointer",
                  background:groupFilter===g.name?G.g50:"transparent",
                  color:groupFilter===g.name?G.g700:G.n700,
                  fontSize:"11px",fontFamily:BODY,
                  fontWeight:groupFilter===g.name?"600":"400",
                  display:"flex",justifyContent:"space-between",alignItems:"center"
                }}>
                  <span>👨‍👩‍👧‍👦 {g.name}</span>
                  <span style={{fontSize:"10px",color:G.n400,marginLeft:"8px"}}>{(g.members||[]).length}m</span>
                </div>
              ))
            }
          </div>
        </>
      )}
    </div>
  );
}

// ─── NAV ICONS ───────────────────────────────────────────────────────────────
function DoneIcon() {
  return <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.6"/><path d="M6.5 10L9 12.5L13.5 7.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>;
}
function HomeIcon() {
  return <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M3 9.5L10 3L17 9.5V17H13V13H7V17H3V9.5Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/></svg>;
}
function ChartIcon() {
  return <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="3" y="11" width="3" height="6" rx="1" stroke="currentColor" strokeWidth="1.6"/><rect x="8.5" y="7" width="3" height="10" rx="1" stroke="currentColor" strokeWidth="1.6"/><rect x="14" y="3" width="3" height="14" rx="1" stroke="currentColor" strokeWidth="1.6"/></svg>;
}
function UserIcon() {
  return <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="7" r="3.5" stroke="currentColor" strokeWidth="1.6"/><path d="M3 17c0-3.314 3.134-6 7-6s7 2.686 7 6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg>;
}
